import React, { Component } from "react";
import Nav from "../Include/Nav";
import Header from "../Header/Header";

import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import Moment from "moment";
import Modal from "react-bootstrap-modal";
import socketIOClient from "socket.io-client";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import baseUrl from "../baseUrl";
import { mockResdata } from "./mockres";

require("react-bootstrap-modal/lib/css/rbm-complete.css");
// const baseUrl = "http://api.encabook999.com:4000";

class Index extends Component {
  constructor(props) {
    super(props);
    var accessToken = localStorage.getItem("token");
    var user_id = localStorage.getItem("user_id");
    this.state = {
      accessToken: accessToken,
      collapsed: false,
      draw: false,
      getFirstLay: false,
      getSecondBack: false,
      user_id: user_id,
      oddsfirstlay: "",
      matchids: "",
      BatAmount_second: "",
      proFitfirstval: "",
      proFitsecondval: "",
      getFancybet: false,
      getFancySecondbet: false,
      pancypickCall: false,
      stake_amount: "",
      respStatus: "",
      respMessage: "",
      emptyField: false,
      loading: true,
      team_profit1: "",
      team_profit2: "",
      new_array: {},
      stackAmount_team1: "",
      stackAmount_team2: "",
      profit22: "",
      profit_team: "",
      loss_team: "",
      profit12: 0,
      profit13: 0,
      profit14: 0,
      loss: 0,
      maxminBet: "",
      fancyDataFound: false,
      getFancyResults: "",
      betClick1: false,
      headname: "",
      SessInptNo: "",
      no: "",
      yes: "",
      status: "",
      buttonvalue_new: "",
      min_bookmaker: "",
      max_bookmaker: "",
      bookmaker_team_a: "",
      bookmaker_back_1: "",
      bookmaker_back_2: "",
      bookmaker_back_3: "",
      bookmaker_lay_2: "",
      bookmaker_lay_3: "",
      bookmaker_b_back_1: "",
      bookmaker_b_back_2: "",
      bookmaker_b_back_3: "",
      bookmaker_b_lay_2: "",
      bookmaker_b_blay_3: "",
      bookmaker_b_status: "",
      no_data_model: "",
      yes_data_model: "",
      color_data_model: "",
      showUserAmountPopup: false,
      key_index: "",
      bookmaker_draw: false,
      bookmakerFirstTeamFound: false,
      bookmakerSecondTeamFound: false,
      fancyMatchSuspend: false,
      oddsMatchSuspend: false,
      showVideo: false,
      showVideoFromAdmin: false,
      currentMatchId: this.props.match.params.id,
      getFancyResultsHide: "",
      showBookMakerLiveApiData: true,
      max_bookmaker_limit: "N/A",
      min_bookmaker_limit: "N/A",
      profit15: 0,
      profit16: 0,
      profit17: 0,
      betUpdateResp: "",
      betUpdateMsg: "",
    };
    this.emailInput = React.createRef();
  }
  fnum = (x) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return x;
    }

    if (x < 1000000) {
      return (x / 1000).toFixed(2) + "K";
    }
    if (x < 10000000) {
      return (x / 1000000).toFixed(2) + "M";
    }

    if (x < 1000000000) {
      return Math.round(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return Math.round(x / 1000000000) + "B";
    }

    return "1T+";
  };

  onFirstLayClick = () => {
    const { getFirstLay } = this.state;
    this.setState(() => ({
      getFirstLay: !getFirstLay,
    }));
  };

  onSecondLayClick = () => {
    const { getSecondBack } = this.state;
    this.setState(() => ({
      getSecondBack: !getSecondBack,
    }));
  };

  betDeleteClickConfirm = (betId, betStatus) => {
    confirmAlert({
      title: "Confirm",
      message: "Are you sure to convert this bet to " + betStatus,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.callDeleteBet(betId, betStatus),
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
    });
  };

  callDeleteBet = (betId, betStatus) => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    var sendBetObj = {
      id: betId,
      status: betStatus,
    };
    axios
      .post(baseUrl + "/updatebetstatus", sendBetObj, { headers })
      .then((resp) => {
        var resp = resp.data;

        this.setState({
          betUpdateResp: resp.success,
          betUpdateMsg: resp.message,
        });
        this.callUserBetListApi();
        setTimeout(() => {
          this.setState({ betUpdateResp: "", betUpdateMsg: "" });
        }, 6000);
      });
  };

  showBetUpdateRespHtml = () => {
    if (this.state.betUpdateResp === true) {
      return (
        <div className="alert alert-success">{this.state.betUpdateMsg}</div>
      );
    } else if (this.state.betUpdateResp === false) {
      return (
        <div className="alert alert-danger">{this.state.betUpdateMsg}</div>
      );
    }
  };

  currentUserDetail = () => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios.get(baseUrl + "/current", { headers }).then((resp) => {
      var resp = resp.data;

      this.setState({ userData: resp });
    });
  };
  getUserCurrentBalance = () => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios
      .get(baseUrl + "/maxbet_minbet/" + this.props.match.params.id, {
        headers,
      })
      .then((resp) => {
        var resp = resp.data;
        this.setState({ maxminBet: resp });
      });
  };

  getFancybet = () => {
    if (this.state.getFancybet === true) {
      return (
        <tr style={{ background: "#F3DCE2" }}>
          <td className="text-center">
            <a href="#" className="text-danger">
              {" "}
              <i className="fa fa-times"></i>{" "}
            </a>
          </td>
          <td id="team_nm">{this.state.teamname1}</td>
          <td style={{ width: "75px" }}>
            <div className="form-group">
              <input
                value={this.state.amountFancybetBal}
                name="amountFancybetBal"
                className="amountint"
                onChange={this.handleChange}
                type="number"
                style={{
                  float: "left",
                  width: "45px",
                  verticalAlign: "middle",
                }}
                id="odds"
                readOnly
                required="required"
              />
            </div>
          </td>
          <td>
            <div className="form-group bet-stake">
              <input
                value={this.state.amountFancybetFirst}
                name="amountFancybetFirst"
                type="text"
                onChange={this.handleChange}
                id="btn_val"
                style={{ width: "52px" }}
                maxLength="10"
                required="required"
              />
            </div>
          </td>{" "}
        </tr>
      );
    }
  };
  getFancybetPoint = () => {
    if (this.state.getFancybet === true) {
      return (
        <tr style={{ background: "#F3DCE2" }}>
          <td colSpan="5" style={{ padding: "5px" }} className="value-buttons">
            <button
              className="btn btn-success btn_dyn"
              value="4"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              4
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="20"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              20
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="30"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              30
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="50"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              50
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="500"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              500
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="1000"
              onClick={(e) => this.onTestClickFancyFirst(e)}
            >
              1000
            </button>
          </td>
        </tr>
      );
    }
  };

  getFirstLayPoint = () => {
    if (this.state.getFirstLay === true) {
      return (
        <tr style={{ background: "#F3DCE2" }}>
          <td colSpan="5" style={{ padding: "5px" }} className="value-buttons">
            <button
              className="btn btn-success btn_dyn"
              value="4"
              onClick={(e) => this.onTestClick(e)}
            >
              4
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="20"
              onClick={(e) => this.onTestClick(e)}
            >
              20
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="30"
              onClick={(e) => this.onTestClick(e)}
            >
              30
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="50"
              onClick={(e) => this.onTestClick(e)}
            >
              50
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="500"
              onClick={(e) => this.onTestClick(e)}
            >
              500
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="1000"
              onClick={(e) => this.onTestClick(e)}
            >
              1000
            </button>
          </td>
        </tr>
      );
    }
  };

  getSecondLayPoint = () => {
    if (this.state.getSecondBack === true) {
      return (
        <tr style={{ background: "#BEDDF4" }}>
          <td colSpan="5" style={{ padding: "5px" }} className="value-buttons">
            <button
              className="btn btn-success btn_dyn"
              value="4"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              4
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="20"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              20
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="30"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              30
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="50"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              50
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="500"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              500
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="1000"
              onClick={(e) => this.onTestClickSecond(e)}
            >
              1000
            </button>
          </td>
        </tr>
      );
    }
  };
  getSecondFancybetPoint = () => {
    if (this.state.getFancySecondbet === true) {
      return (
        <tr style={{ background: "#BEDDF4" }}>
          <td colSpan="5" style={{ padding: "5px" }} className="value-buttons">
            <button
              className="btn btn-success btn_dyn"
              value="4"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              4
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="20"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              20
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="30"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              30
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="50"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              50
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="500"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              500
            </button>
            <button
              className="btn btn-success btn_dyn"
              value="1000"
              onClick={(e) => this.onTestClickFancySecond(e)}
            >
              1000
            </button>
          </td>
        </tr>
      );
    }
  };

  getFirstLay = () => {
    if (this.state.getFirstLay === true) {
      return (
        <tr style={{ background: "#F3DCE2" }}>
          <td className="text-center">
            <a href="#" className="text-danger">
              {" "}
              <i className="fa fa-times"></i>{" "}
            </a>
          </td>
          <td id="team_nm">{this.state.teamname1}</td>
          <td style={{ width: "75px" }}>
            <div className="form-group">
              <input
                value={this.state.lastPriceTraded1}
                name="lastPriceTraded1"
                className="amountint"
                onChange={this.handleChange}
                type="text"
                style={{
                  float: "left",
                  width: "45px",
                  verticalAlign: "middle",
                }}
                id="odds"
                required="required"
                readOnly
              />
            </div>
          </td>
          <td>
            <div className="form-group bet-stake">
              <input
                value={this.state.amountshowFirst}
                name="amountshowFirst"
                type="text"
                onChange={this.handleChange}
                id="btn_val"
                style={{ width: "52px" }}
                maxLength="10"
                required="required"
              />
            </div>
          </td>{" "}
          <td id="prft" className="text-right">
            <input
              value={this.state.proFitfirstval}
              name="proFitsecondval"
              onChange={this.handleChange}
              type="text"
              readOnly
              style={{ float: "left", width: "45px", verticalAlign: "middle" }}
            />
          </td>
        </tr>
      );
    }
  };
  getSecondBack = () => {
    if (this.state.getSecondBack === true) {
      return (
        <tr style={{ background: "#BEDDF4" }}>
          <td className="text-center">
            <a href="#" className="text-danger">
              {" "}
              <i className="fa fa-times"></i>{" "}
            </a>
          </td>
          <td id="team_nm">{this.state.teamname2}</td>
          <td style={{ width: "75px" }}>
            <div className="form-group">
              <input
                value={this.state.lastPriceTraded2}
                name="lastPriceTraded2"
                className="amountint"
                onChange={this.handleChange}
                type="number"
                required="required"
                maxLength="4"
                style={{
                  float: "left",
                  width: "45px",
                  verticalAlign: "middle",
                }}
                id="odds"
              />
            </div>
          </td>
          <td>
            <div className="form-group bet-stake">
              <input
                id="btn_val"
                style={{ width: "52px" }}
                maxLength="10"
                value={this.state.amountshowSecond}
                type="text"
                onChange={this.handleChange}
                required="required"
              />
            </div>
          </td>
          <td id="prft" className="text-right">
            <input
              value={this.state.proFitsecondval}
              name="proFitsecondval"
              onChange={this.handleChange}
              type="text"
              readOnly
              style={{ float: "left", width: "45px", verticalAlign: "middle" }}
            />
          </td>
        </tr>
      );
    }
  };
  getFancySecondbet = () => {
    if (this.state.getFancySecondbet === true) {
      return (
        <tr style={{ background: "#BEDDF4" }}>
          <td className="text-center">
            <a href="#" className="text-danger">
              {" "}
              <i className="fa fa-times"></i>{" "}
            </a>
          </td>
          <td id="team_nm">{this.state.teamname2}</td>
          <td style={{ width: "75px" }}>
            <div className="form-group">
              <input
                value={this.state.amountFancybetBalSecond}
                name="lastPriceTraded2"
                className="amountint"
                onChange={this.handleChange}
                type="number"
                required="required"
                maxLength="4"
                style={{
                  float: "left",
                  width: "45px",
                  verticalAlign: "middle",
                }}
                id="odds"
                readOnly
              />
            </div>
          </td>
          <td>
            <div className="form-group bet-stake">
              <input
                id="btn_val"
                style={{ width: "52px" }}
                maxLength="10"
                value={this.state.amountFancybetSecond}
                type="text"
                onChange={this.handleChange}
                required="required"
              />
            </div>
          </td>{" "}
        </tr>
      );
    }
  };

  onTestClick(e) {
    e.preventDefault();
    const buttonValue = e.target.value;
    var minusone = this.state.lastPriceTraded1 - 1;
    var multiplyval = minusone * buttonValue;
    var numValue = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 2,
    }).format(multiplyval);

    this.setState({
      amountshowFirst: buttonValue,
      proFitfirstval: numValue,
    });
  }
  onTestClickSecond(e) {
    e.preventDefault();
    const buttonValue = e.target.value;
    var minusone = this.state.lastPriceTraded2 - 1;
    var multiplyval = minusone * buttonValue;
    var numValue = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 2,
    }).format(multiplyval);

    this.setState({
      amountshowSecond: buttonValue,
      proFitsecondval: numValue,
    });
  }

  onTestClickFancyFirst(e) {
    e.preventDefault();
    const buttonValue = e.target.value;
    var minusone = this.state.lastPriceTraded1 - 1;
    var multiplyval = minusone * buttonValue;
    var numValue = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 2,
    }).format(multiplyval);

    this.setState({
      amountFancybetFirst: buttonValue,
    });
  }
  onTestClickFancySecond(e) {
    e.preventDefault();
    const buttonValue = e.target.value;
    var minusone = this.state.lastPriceTraded1 - 1;
    var multiplyval = minusone * buttonValue;
    var numValue = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 2,
    }).format(multiplyval);

    this.setState({
      amountFancybetSecond: buttonValue,
    });
  }
  cancelCourse = () => {
    window.location = "/matchdetail/" + this.state.matchids;
    //this.setState({ amountshowFirst: "", amountshowSecond: "", proFitfirstval: "", proFitsecondval: "" });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };

    let matchid = this.props.match.params.id;
    let compareMainAmount = "";
    let current_market_odds = "";
    let type = "unmatch";
    if (this.state.betMatchType === "teamone" && this.state.type === "back") {
      compareMainAmount = this.state.teamOneFirstBack;
      current_market_odds = this.state.teamOneFirstBack;
    } else if (
      this.state.betMatchType === "teamone" &&
      this.state.type === "lay"
    ) {
      compareMainAmount = this.state.teamOneFirstLay;
      current_market_odds = this.state.teamOneFirstLay;
    } else if (
      this.state.betMatchType === "teamtwo" &&
      this.state.type === "back"
    ) {
      compareMainAmount = this.state.teamTwoFirstBack;
      current_market_odds = this.state.teamTwoFirstBack;
    } else if (
      this.state.betMatchType === "teamtwo" &&
      this.state.type === "lay"
    ) {
      compareMainAmount = this.state.teamTwoFirstLay;
      current_market_odds = this.state.teamTwoFirstLay;
    } else if (
      this.state.betMatchType === "draw" &&
      this.state.type === "back"
    ) {
      compareMainAmount = this.state.drawFirstBack;
      current_market_odds = this.state.drawFirstBack;
    } else if (
      this.state.betMatchType === "draw" &&
      this.state.type === "lay"
    ) {
      compareMainAmount = this.state.drawFirstLay;
      current_market_odds = this.state.drawFirstLay;
    }

    if (this.state.betOn === "manual_bookmaker") {
      if (this.state.betMatchType === "teamone" && this.state.type === "back") {
        compareMainAmount = this.state.bookMakerAdminData.first_team_back;
        current_market_odds = this.state.bookMakerAdminData.first_team_back;
      } else if (
        this.state.betMatchType === "teamone" &&
        this.state.type === "lay"
      ) {
        compareMainAmount = this.state.bookMakerAdminData.first_team_lay;
        current_market_odds = this.state.bookMakerAdminData.first_team_lay;
      } else if (
        this.state.betMatchType === "teamtwo" &&
        this.state.type === "back"
      ) {
        compareMainAmount = this.state.bookMakerAdminData.second_team_back;
        current_market_odds = this.state.bookMakerAdminData.second_team_back;
      } else if (
        this.state.betMatchType === "teamtwo" &&
        this.state.type === "lay"
      ) {
        compareMainAmount = this.state.bookMakerAdminData.second_team_lay;
        current_market_odds = this.state.bookMakerAdminData.second_team_lay;
      } else if (
        this.state.betMatchType === "draw" &&
        this.state.type === "back"
      ) {
        compareMainAmount = this.state.bookMakerAdminData.draw_back;
        current_market_odds = this.state.bookMakerAdminData.draw_back;
      } else if (
        this.state.betMatchType === "draw" &&
        this.state.type === "lay"
      ) {
        compareMainAmount = this.state.bookMakerAdminData.draw_lay;
        current_market_odds = this.state.bookMakerAdminData.draw_lay;
      }
    }

    if (compareMainAmount === this.state.oddVal) {
      type = "match";
    }

    var loss = "";
    var new_array = [];
    var loss_team = "";
    var newpath = 0;
    if (this.state.betMatchType == "teamone") {
      loss = this.state.stackAmount_team2;
      if (this.state.stackAmount_team2 != undefined) {
        newpath = Math.abs(this.state.stackAmount_team2);
      }

      loss_team = "teamtwo";
    }
    if (this.state.betMatchType == "teamtwo") {
      loss = this.state.stackAmount_team1;
      if (this.state.stackAmount_team1 != undefined) {
        newpath = Math.abs(this.state.stackAmount_team1);
      }

      loss_team = "teamone";
    }

    if (isNaN(parseInt(this.state.oddVal)) || this.state.oddVal <= 0) {
      this.setState({ emptyField: true, errMsg: "Enter Valid Odds" });
      return false;
    }
    if (
      isNaN(parseInt(this.state.stake_amount)) ||
      this.state.stake_amount <= 0
    ) {
      this.setState({ emptyField: true, errMsg: "Enter Stake" });
      return false;
    }

    let savebet = {
      event_id: this.props.match.params.id,
      event_name: this.state.eventName,
      odds: this.state.oddVal,
      stake: this.state.stake_amount,
      profit: this.state.profit,
      bet_type: this.state.type,
      type: type,
      team_name: this.state.teamName,
      selection_id: this.state.betSelectionId,
      market_id: this.state.betMarketId,
      current_market_odds: current_market_odds,
      profit_team: this.state.betMatchType,
      loss_team: loss_team,
      loss: newpath,
      color: this.state.color,
      event_type: this.props.match.params.id1,
      type1: "odds",
      bet_on: this.state.betOn,
    };

    axios
      .post(baseUrl + "/createbetuser", savebet, { headers })
      .then((resp) => {
        var resp = resp.data;
        if (resp.success === true) {
          this.setState({
            respStatus: resp.success,
            respMessage: resp.message,
            oddVal: "",
            stake_amount: "",
            profit: "",
            team_profit1: "",
            stackAmount_team1: "",
            team_profit2: "",
            stackAmount_team2: "",
            stackAmount_team3: "",
            team_profit3: "",
          });
          this.getUserCurrentBalance();
          this.showTableHtml();
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
        } else {
          this.setState({
            respStatus: resp.success,
            respMessage: resp.message,
          });
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
        }
        this.callUserBetListApi();
      });
  };
  handleSubmitSession = (event) => {
    event.preventDefault();
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };

    let matchid = this.props.match.params.id;
    var yes_amount = "";
    var no_amount = "";
    var new_value = "";

    if (this.state.no === "no") {
      new_value = this.state.session_input;
      no_amount = this.state.session_input;
    }
    if (this.state.yes === "yes") {
      new_value = this.state.session_input;
      yes_amount = this.state.session_input;
    }
    let savebet = {
      event_id: this.props.match.params.id,
      event_name: this.state.eventName,
      yes: this.state.yes,
      no: this.state.no,
      market_id: this.state.betMarketId,
      yes_amount: this.satat,
      no_amount: no_amount,
      stake: this.state.stake_amount,
      headname: this.state.headname,
      team_name: this.state.headname,
      odds: new_value,
      bet_type: "fancy",
      color: this.state.color,
      key_index: this.state.key_index,
      event_type: this.props.match.params.id1,
      type1: "fancy",
      yes_no_stake: this.state.yes_no_STAKE,
      bet_on: "fancy",
    };

    axios
      .post(baseUrl + "/createbetuser", savebet, { headers })
      .then((resp) => {
        var resp = resp.data;
        if (resp.success === true) {
          this.setState({
            respStatus: resp.success,
            respMessage: resp.message,
            oddVal: "",
            stake_amount: "",
            profit: "",
            team_profit1: "",
            stackAmount_team1: "",
            team_profit2: "",
            stackAmount_team2: "",
          });
          this.getUserCurrentBalance();
          this.showTableHtml();
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
        } else {
          this.setState({
            respStatus: resp.success,
            respMessage: resp.message,
          });
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
        }
        this.callUserBetListApi();
      });
  };

  responseHtml = () => {
    if (this.state.respStatus === false) {
      return <div className="alert alert-danger">{this.state.respMessage}</div>;
    } else if (this.state.respStatus === true) {
      return (
        <div className="alert alert-success">{this.state.respMessage}</div>
      );
    }
  };

  emptyHtml = () => {
    if (this.state.emptyField === true) {
      return <div className="alert alert-danger">{this.state.errMsg}</div>;
    }
  };

  handleFancybetSubmit = (event) => {
    event.preventDefault();
    let savebet = {
      event_id: this.props.match.params.id,
      user_id: this.state.user_id,
      team_id: this.state.teamid1,
      team_id_second: this.state.teamid2,
      matchids: this.state.matchids,
      eventName: this.state.eventName,
      Odds: this.state.marketName,
      odds_first_lay: this.state.amountFancybetBal,
      odds_second_lay: this.state.amountFancybetBalSecond,
      teamname: this.state.teamname1,
      teamname_second: this.state.teamname2,
      BatAmount: this.state.amountFancybetFirst * this.state.amountFancybetBal,
      BatAmount_second:
        this.state.amountFancybetSecond * this.state.amountFancybetBalSecond,
      eventTypeId: this.state.eventTypeId,
      color: this.state.color,
      event_type: this.props.match.params.id1,
      type1: "bookmaker",
    };
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios
      .post(baseUrl + "/createbetuser", savebet, { headers })
      .then((resp) => {
        if (resp.data.success != false) {
          this.setState({
            respStatus: resp.success,
            stake_amount: "",
            profit4: "",
            team_profit1: "",
            stackAmount_team4: "",
            team_profit5: "",
            stackAmount_team5: "",
            stackAmount_team6: "",
            team_profit6: "",
          });
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
          window.location.href = "/matchdetail/" + resp.data.result.matchids;
        } else {
          this.setState({
            respMessage: resp.data.message,
          });
          setTimeout(() => {
            this.setState({
              respStatus: "",
              betClick1: false,
              betClick: false,
            });
          }, 6000);
        }
      });
  };

  componentDidMount() {
    // this.getoddsValue();
    // this.interval = setInterval(() => {
    //   this.getoddsValue();
    // }, 1000);
    this.getUserCurrentBalance();
    this.callUserBetListApi();
    // this.callFancyListApi();
    this.currentUserDetail();
    let matchid = this.props.match.params.id;

    const length = window.location.pathname.split("/").length;
    let query = window.location.pathname.split("/")[length - 1];
    if (window.location.pathname.split("/")[length - 1] === "soccer") {
      query = "football";
    }
    // axios
    //   .post("http://95.111.217.38:8080/DiamondApi/GetSportsMarket", {
    //     textQuery: query,
    //     marketIds: [],
    //     eventIds: [matchid],
    //     eventTypeIds: [],
    //     inPlayOnly: true,
    //   })
    //   .then((res) => {
    //     console.log(res.data.SportsData[0]);
    //     this.callMatchOddsApi(res.data.SportsData[0]);
    //       this.callBookmakerApi();
    //       this.callFancyListApi();
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // console.log("intervae set");
    // setInterval(() => {
    this.callBookmakerApi();
    this.callFancyListApi();
    axios
      .post("http://95.111.217.38:8080/DiamondApi/GetSportsMarket", {
        textQuery: query,
        marketIds: [],
        eventIds: [matchid],
        eventTypeIds: [],
        inPlayOnly: false,
      })
      .then((res) => {
        console.log(res.data.SportsData[0]);
        this.callMatchOddsApi(res.data.SportsData[0]);
      })
      .catch((error) => {
        console.log(error);
      });
    // }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  getoddsValue() {
    // const data = {
    //   match_id: this.props.match.params.id,
    //   sport_type: this.props.match.params.id1,
    // };

    const data = {
      textQuery: "cricket",
      marketIds: [],
      eventIds: ["31105043"],
      eventTypeIds: [],
      inPlayOnly: false,
    };

    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios
      .post("http://95.111.217.38:8080/DiamondApi/GetSportsMarket/", data, {
        headers,
      })
      .then((resp) => {
        if (resp) {
          this.callMatchOddsApi(resp.data);
        }
      });
  }

  // callFancyListApi = () => {
  //   let headers = {
  //     Authorization: 'Bearer ' + this.state.accessToken,
  //   };

  //   let matchid = this.props.match.params.id;
  //   axios.get(baseUrl + '/fancyapi/' + matchid, { headers }).then((resp) => {
  //     var matchSuspendFromAdmin = resp.data.suspendcount === 0 ? false : true;
  //     this.setState({
  //       getFancyResults: resp.data.alldata.data,
  //       fancyDataFound: true,
  //       fancyMatchSuspend: matchSuspendFromAdmin,
  //     });
  //   });
  //   $('.blockUI').hide();
  // };
  callFancyListApi = () => {
    // let headers = {
    //   Authorization: "Bearer " + this.state.accessToken,
    // };

    // let matchid = this.props.match.params.id;
    // this.callMatchOddsApi()
    // axios.get(baseUrl + "/fancyapi/" + matchid, { headers }).then((resp) => {
    //   var matchSuspendFromAdmin = resp.data.suspendcount === 0 ? false : true;
    //   this.setState({
    //     getFancyResults: resp.data.alldata.data,
    //     fancyDataFound: true,
    //     fancyMatchSuspend: matchSuspendFromAdmin,
    //   });
    // });
    // axios.get(baseUrl + '/fancy_result_admin/1/'+matchid, { headers }).then((respFancy) => {
    // 	//////console.logrespFancy);
    // 	this.setState({ getFancyResultsHide: respFancy.data.hide_show,  });
    // });
    this.setState({
      getFancyResults: mockResdata.data.t3,
      fancyDataFound: true,
      fancyMatchSuspend: false,
    });
    $(".blockUI").hide();
  };
  handleModelShow = (id, no, yes, no_stake, yes_stake) => {
    //////console.logno);
    //////console.logyes);
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    let savebet = {
      match_id: id,
    };

    // this.callMatchOddsApi()
    axios.post(baseUrl + "/userbetdata", savebet, { headers }).then((resp) => {
      this.setState({ no_data_model: resp, showUserAmountPopup: true });
    });
  };

  // showFancyApiHtml = () => {
  //   if (this.state.fancyDataFound === true) {
  //     const html = [];
  //     var new_array = [];
  //     var new_array1 = [];
  //     var new_array2 = [];

  //     if (this.state.getResults != undefined) {
  //       for (var i = 0; i < this.state.getResults.length; i++) {
  //         if (this.state.getResults.bet_type == 'fancy') {
  //           if (
  //             this.state.getResults.key_index != null &&
  //             this.state.getResults.key_index != undefined
  //           ) {
  //             new_array[this.state.getResults.key_index] =
  //               this.state.getResults.key_index;
  //             new_array1[this.state.getResults.key_index] =
  //               this.state.getResults.stake;
  //             new_array2[this.state.getResults.key_index] =
  //               this.state.getResults._id;
  //           }
  //         }
  //       }
  //     }

  //     if (this.state.getFancyResultsHide !== undefined) {
  //       var index = 0;
  //       var i = 0;
  //       var hideMatchArr1 = ['demo'];
  //       //////console.logthis.state.getFancyResultsHide);
  //       if (this.state.getFancyResultsHide !== null) {
  //         if (
  //           this.state.getFancyResultsHide != undefined &&
  //           this.state.getFancyResultsHide != null &&
  //           this.state.getFancyResultsHide != ''
  //         ) {
  //           for (var bn = 0; bn < this.state.getFancyResultsHide.length; bn++) {
  //             if (
  //               this.state.getFancyResultsHide[bn].hide == 'suspended' ||
  //               this.state.getFancyResultsHide[bn].hide == 'suspend'
  //             ) {
  //               hideMatchArr1.push(
  //                 this.state.getFancyResultsHide[bn].market_id
  //               );
  //             }
  //           }
  //         }
  //       }

  //       if (this.state.getFancyResults != undefined) {
  //         for (let fancyNewData of Object.values(this.state.getFancyResults)) {
  //           var blockHtml = '';
  //           //////console.loghideMatchArr1.indexOf(fancyNewData.market_id));
  //           if (hideMatchArr1.indexOf(fancyNewData.market_id) != '-1') {
  //             var blockHtml = (
  //               <div className="bet-info suspendedfancy row">
  //                 <span>SUSPENDED</span>
  //               </div>
  //             );
  //           }

  //           var new_value = '';
  //           var new_value1 = '';

  //           if (
  //             this.state.fancyMatchSuspend &&
  //             hideMatchArr1.indexOf(fancyNewData.market_id) == '-1'
  //           ) {
  //             var blockHtml = (
  //               <div className="bet-info suspendedfancy row">
  //                 <span>SUSPENDED</span>
  //               </div>
  //             );
  //           } else if (hideMatchArr1.indexOf(fancyNewData.market_id) == '-1') {
  //             var blockHtml =
  //               fancyNewData.DisplayMsg != '' ? (
  //                 <div className="bet-info suspendedfancy row">
  //                   <span>{fancyNewData.DisplayMsg}</span>
  //                 </div>
  //               ) : (
  //                 ''
  //               );
  //           }

  //           if (fancyNewData.market_id == new_array[fancyNewData.market_id]) {
  //             if (
  //               fancyNewData.SessInptNo !== undefined &&
  //               fancyNewData.SessInptYes !== undefined
  //             ) {
  //               //if(fancyNewData.DisplayMsg!="SUSPENDED"){
  //               html.push(
  //                 <tr>
  //                   <td className="fb_64">
  //                     <a href="#">
  //                       {' '}
  //                       {fancyNewData.headname}
  //                       &nbsp;(-{new_array1[fancyNewData.market_id]} )
  //                     </a>
  //                     <button
  //                       className="tableman_btn"
  //                       onClick={this.handleModelShow.bind(
  //                         this,
  //                         fancyNewData.market_id,
  //                         fancyNewData.SessInptNo,
  //                         fancyNewData.SessInptYes
  //                       )}
  //                     >
  //                       Book
  //                     </button>
  //                   </td>
  //                   <td className="box-w1 lay-color fb_td">
  //                     {blockHtml}
  //                     <button
  //                       className="bet-sec lay"
  //                       value={i}
  //                       onClick={this.handleBidClickSession.bind(
  //                         this,
  //                         '#faa9ba',
  //                         fancyNewData.headname,
  //                         'no',
  //                         this.state.marketId,
  //                         fancyNewData.SessInptNo,
  //                         '',
  //                         fancyNewData.market_id
  //                       )}
  //                     >
  //                       <span className="odd layprice">
  //                         {' '}
  //                         {fancyNewData.SessInptNo}
  //                       </span>
  //                       {fancyNewData.NoValume}
  //                     </button>
  //                   </td>

  //                   <td className="box-w1 back-color fb_td">
  //                     <button
  //                       value={i}
  //                       onClick={this.handleBidClickSession.bind(
  //                         this,
  //                         '#72bbef',
  //                         fancyNewData.headname,
  //                         'yes',
  //                         this.state.marketId,
  //                         fancyNewData.SessInptYes,
  //                         '',
  //                         fancyNewData.market_id
  //                       )}
  //                       className="bet-sec lay"
  //                     >
  //                       <span className="odd layprice">
  //                         {' '}
  //                         {fancyNewData.SessInptYes}
  //                       </span>
  //                       {fancyNewData.YesValume}
  //                     </button>
  //                   </td>

  //                   <td className="fb_td" style={{ textAlign: 'center' }}>
  //                     {' '}
  //                     Min 10 <br /> Max 10000{' '}
  //                   </td>
  //                 </tr>
  //               );
  //               //}
  //             }
  //           } else {
  //             if (
  //               fancyNewData.SessInptNo !== undefined &&
  //               fancyNewData.SessInptYes !== undefined
  //             ) {
  //               //if(fancyNewData.DisplayMsg!="SUSPENDED"){
  //               html.push(
  //                 <tr>
  //                   <td className="fb_64"> {fancyNewData.headname}</td>
  //                   <td className="box-w1 lay-color">
  //                     {' '}
  //                     {blockHtml}
  //                     <button
  //                       className="bet-sec lay"
  //                       value={i}
  //                       onClick={this.handleBidClickSession.bind(
  //                         this,
  //                         '#faa9ba',
  //                         fancyNewData.headname,
  //                         'no',
  //                         this.state.marketId,
  //                         fancyNewData.SessInptNo,
  //                         '',
  //                         fancyNewData.market_id,
  //                         fancyNewData.SessInptYes
  //                       )}
  //                     >
  //                       <span className="odd layprice">
  //                         {' '}
  //                         {fancyNewData.SessInptNo}
  //                       </span>
  //                       {fancyNewData.NoValume}
  //                     </button>
  //                   </td>

  //                   <td className="box-w1 back-color fb_td">
  //                     <button
  //                       value={i}
  //                       onClick={this.handleBidClickSession.bind(
  //                         this,
  //                         '#72bbef',
  //                         fancyNewData.headname,
  //                         'yes',
  //                         this.state.marketId,
  //                         fancyNewData.SessInptYes,
  //                         '',
  //                         fancyNewData.market_id,
  //                         fancyNewData.SessInptNo
  //                       )}
  //                       className="bet-sec lay"
  //                     >
  //                       <span className="odd layprice">
  //                         {' '}
  //                         {fancyNewData.SessInptYes}
  //                       </span>
  //                       {fancyNewData.YesValume}
  //                     </button>
  //                   </td>

  //                   <td className="fb_td" style={{ textAlign: 'center' }}>
  //                     {' '}
  //                     Min 10 <br /> Max 10000{' '}
  //                   </td>
  //                 </tr>
  //               );
  //               //}
  //             }
  //           }

  //           //if(fancyNewData.SessInptNo > 0 && fancyNewData.SessInptYes>0) {

  //           //}
  //           index++;
  //           i++;
  //         }
  //       }
  //       //getFancyResultsHide
  //     }

  //     return (
  //       <table className="coupon-table table table-bordered">
  //         <thead>
  //           <tr>
  //             <th> &nbsp;</th>
  //             <th className="text-center  box-w1 lay"> No </th>
  //             <th
  //               className="text-center  box-w1 back"
  //               style={{ backgroundColor: '#72BBEF' }}
  //             >
  //               {' '}
  //               Yes{' '}
  //             </th>
  //             <th className="box-w2"> &nbsp; </th>
  //           </tr>
  //         </thead>
  //         <tbody>{html}</tbody>
  //       </table>
  //     );
  //   }
  // };
  showFancyApiHtml = () => {
    console.log("facy function started");
    if (this.state.fancyDataFound === true) {
      const html = [];
      var new_array = [];
      var new_array1 = [];
      var new_array2 = [];

      if (this.state.getResults !== undefined) {
        for (var i = 0; i < this.state.getResults.length; i++) {
          if (this.state.getResults[i].gtype === "fancy") {
            if (
              this.state.getResults[i].mid !== null &&
              this.state.getResults[i].mid !== undefined
            ) {
              new_array[this.state.getResults[i].mid] =
                this.state.getResults[i].mid;
              new_array1[this.state.getResults[i].mid] =
                this.state.getResults[i].stake;
              new_array2[this.state.getResults[i].mid] =
                this.state.getResults[i]._id;
            }
          }
        }
      }

      if (this.state.getFancyResultsHide !== undefined) {
        var index = 0;
        var i = 0;
        var hideMatchArr1 = ["demo"];
        console.log(this.state.getFancyResultsHide);
        if (this.state.getFancyResultsHide !== null) {
          if (
            this.state.getFancyResultsHide !== undefined &&
            this.state.getFancyResultsHide !== null &&
            this.state.getFancyResultsHide !== ""
          ) {
            for (var bn = 0; bn < this.state.getFancyResultsHide.length; bn++) {
              if (
                this.state.getFancyResultsHide[bn].hide === "suspended" ||
                this.state.getFancyResultsHide[bn].hide === "suspend"
              ) {
                hideMatchArr1.push(this.state.getFancyResultsHide[bn].mid);
              }
            }
          }
        }
        // array.forEach(element => {

        // });
        if (this.state.getFancyResults !== undefined) {
          this.state.getFancyResults.forEach((fancyNewData) => {
            // console.log(fancyNewData)
            var blockHtml = "";
            // console.log(hideMatchArr1)
            // console.log(fancyNewData.mid)
            // console.log(hideMatchArr1.indexOf(fancyNewData.mid))
            //////console.loghideMatchArr1.indexOf(fancyNewData.market_id));
            if (hideMatchArr1.indexOf(fancyNewData.mid) !== -1) {
              var blockHtml = (
                <div className="bet-info suspendedfancy row">
                  <span>SUSPENDED</span>
                </div>
              );
            }

            var new_value = "";
            var new_value1 = "";

            hideMatchArr1.forEach((hidden) => {
              console.log(hidden, fancyNewData.mid);
              if (
                this.state.fancyMatchSuspend &&
                hidden.indexOf(fancyNewData.mid) > -1
              ) {
                var blockHtml = (
                  <div className="bet-info suspendedfancy row">
                    <span>SUSPENDED</span>
                  </div>
                );
              } else if (hidden.indexOf(fancyNewData.mid) > -1) {
                var blockHtml =
                  fancyNewData.gstatus !== "" ? (
                    <div className="bet-info suspendedfancy row">
                      <span>{fancyNewData.gstatus}</span>
                    </div>
                  ) : (
                    ""
                  );
              }
            });

            if (fancyNewData.mid === new_array[fancyNewData.mid]) {
              if (
                fancyNewData.l1 !== undefined &&
                fancyNewData.b1 !== undefined
              ) {
                //if(fancyNewData.DisplayMsg!="SUSPENDED")     {
                html.push(
                  <tr>
                    <td className="fb_64">
                      <a href="#">
                        {" "}
                        {fancyNewData.nat}
                        &nbsp;(-{new_array1[fancyNewData && fancyNewData.mid]} )
                      </a>
                      <button
                        className="tableman_btn"
                        onClick={this.handleModelShow.bind(
                          this,
                          fancyNewData.mid,
                          fancyNewData.l1,
                          fancyNewData.b1
                        )}
                      >
                        Book
                      </button>
                    </td>
                    <td className="box-w1 lay-color fb_td">
                      {blockHtml}
                      <button
                        className="bet-sec lay"
                        value={i}
                        onClick={this.handleBidClickSession.bind(
                          this,
                          "#faa9ba",
                          fancyNewData.nat,
                          "no",
                          this.state.marketId,
                          fancyNewData.l1,
                          "",
                          fancyNewData.mid
                        )}
                      >
                        <span className="odd layprice"> {fancyNewData.l1}</span>
                        {fancyNewData.ls1}
                      </button>
                    </td>

                    <td className="box-w1 back-color fb_td">
                      <button
                        value={i}
                        onClick={this.handleBidClickSession.bind(
                          this,
                          "#72bbef",
                          fancyNewData.nat,
                          "yes",
                          this.state.marketId,
                          fancyNewData.b1,
                          "",
                          fancyNewData.drawMiddleBack
                        )}
                        className="bet-sec lay"
                      >
                        <span className="odd layprice"> {fancyNewData.b1}</span>
                        {fancyNewData.bs1}
                      </button>
                    </td>

                    <td className="fb_td" style={{ textAlign: "center" }}>
                      {" "}
                      Min {this.state.min_fancy_limit} <br /> Max{" "}
                      {this.state.max_fancy_limit}{" "}
                    </td>
                  </tr>
                );
                //}
              }
            } else {
              if (
                fancyNewData.b1 !== undefined &&
                fancyNewData.l1 !== undefined
              ) {
                //if(fancyNewData.DisplayMsg!="SUSPENDED"){
                html.push(
                  <tr>
                    <td className="fb_64"> {fancyNewData.nat}ssss</td>
                    <td className="box-w1 lay-color">
                      {" "}
                      {blockHtml}
                      <button
                        className="bet-sec lay"
                        value={i}
                        onClick={this.handleBidClickSession.bind(
                          this,
                          "#faa9ba",
                          fancyNewData.nat,
                          "no",
                          this.state.marketId,
                          fancyNewData.l1,
                          "",
                          fancyNewData.market_id,
                          fancyNewData.b1
                        )}
                      >
                        <span className="odd layprice"> {fancyNewData.l1}</span>
                        {fancyNewData.ls1}
                      </button>
                    </td>

                    <td className="box-w1 back-color fb_td">
                      <button
                        value={i}
                        onClick={this.handleBidClickSession.bind(
                          this,
                          "#72bbef",
                          fancyNewData.nat,
                          "yes",
                          this.state.marketId,
                          fancyNewData.b1,
                          "",
                          fancyNewData.mid,
                          fancyNewData.l1
                        )}
                        className="bet-sec lay"
                      >
                        <span className="odd layprice"> {fancyNewData.b1}</span>
                        {fancyNewData.bs1}
                      </button>
                    </td>

                    <td className="fb_td" style={{ textAlign: "center" }}>
                      {" "}
                      Min {this.state.min_fancy_limit} <br /> Max{" "}
                      {this.state.max_fancy_limit}{" "}
                    </td>
                  </tr>
                );
                //}
              }
            }

            //if(fancyNewData.SessInptNo > 0 && fancyNewData.SessInptYes>0) {

            //}
            index++;
            i++;
          });
        }
        //getFancyResultsHide
      }

      return (
        <table className="coupon-table table table-bordered">
          <thead>
            <tr>
              <th> &nbsp;</th>
              <th className="text-center  box-w1 lay"> No </th>
              <th
                className="text-center  box-w1 back"
                style={{ backgroundColor: "#72BBEF" }}
              >
                {" "}
                Yes{" "}
              </th>
              <th className="box-w2"> &nbsp; </th>
            </tr>
          </thead>
          <tbody>{html}</tbody>
        </table>
      );
    }
  };

  callUserBetListApi = async () => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };

    let matchid = this.props.match.params.id;
    axios
      .get(baseUrl + "/getuserbetmatchesid/" + matchid, { headers })
      .then((resp) => {
        var resps = resp.data;
        console.log("resp.data", resp.data);
        this.setState({ getResults: resps.data, betDataFound: true });
      });

    axios
      .get(baseUrl + "/getuserbetmatches1/" + matchid, { headers })
      .then((resp) => {
        var resps = resp.data;
        if (resps.data[0] != undefined) {
          this.setState({
            first_team_data: resps.data[0].firstTeamTotal,
            second_team_data: resps.data[0].secondTeamTotal,
            drawTeamTotal: resps.data[0].drawTeamTotal,
          });
        }
        //this.setState({oddsdata:resps.data[0]})
      });

    axios
      .get(baseUrl + "/getuserbetmatchesbookmaker/" + matchid, { headers })
      .then((resp) => {
        var resps = resp.data;
        if (resps.data[0] != undefined) {
          this.setState({
            first_team_data1: resps.data[0].firstTeamTotal,
            second_team_data1: resps.data[0].secondTeamTotal,
            drawTeamTota1: resps.data[0].drawTeamTotal,
          });
        }
      });

    await axios
      .get(baseUrl + "/getuserbetmatchesfancy/" + matchid, { headers })
      .then((resp) => {
        let resps = resp.data;
        let Data = resps.data ? resps.data : [];
        var holder = {};

        Data.forEach(function (d) {
          if (holder.hasOwnProperty(d.teamname)) {
            holder[d.teamname] = holder[d.teamname] + d.stake;
          } else {
            holder[d.teamname] = d.stake;
          }
        });

        var obj2 = [];
        for (var prop in holder) {
          obj2.push({ teamname: prop, stake: holder[prop] });
        }
        this.setState({ data123: obj2 ? obj2 : resps.data });
      });
  };
  callMatchOddsApi = (
    data,
    isSuspend,
    fancyInActiveList,
    fancySuspendList,
    unmatchOddStatus
  ) => {
    console.log(data);
    const new_array = {};
    //////console.logdata);
    //var getResult1 = data.data
    // var matchOpenDate = data.data1[0].open_date;
    // this.setState({getResult11:resp,openMatchDate:matchOpenDate})

    //new_array['bookmaker_min']=bookmaker[0]
    // ////////////console.logbookmaker.t2[0]);

    // var matchSuspendFromAdmin = (data.suspendcount===0) ? false : true
    // var showVideoFromAdminCheck = (data.show_tv===0) ? false : true

    // new_array['oddsMatchSuspend']=matchSuspendFromAdmin;
    // new_array['showVideoFromAdmin']=showVideoFromAdminCheck;

    // 	Object.values(getResult1[0]).forEach(getResult => {

    // 	//////console.logresp2[0].match_name);
    // 	//////console.loggetResult);
    // 	var explode = resp2[0].match_name.split(" v ");
    // 	let headers = {
    // 		Authorization: "Bearer " + this.state.accessToken,
    // 	};
    // if(getResult.status==="SUSPENDED") {
    // 	axios.get(baseUrl + '/savematchresult/'+getResult.marketId, {headers}).then((respMain) => {
    // 		// // ////////////console.logrespMain);
    // 	});
    // }

    new_array["unmatchOddStatus"] = unmatchOddStatus;
    new_array["fancyInActiveList"] = fancyInActiveList;
    new_array["fancySuspendList"] = fancySuspendList;
    new_array["isSuspend"] = isSuspend;
    new_array["eventName"] =
      data.marketBook.runners[0].runnerName +
      " v " +
      data.marketBook.runners[1].runnerName;
    // new_array['firstTeamName']=  explode[0];
    // new_array['status']=  getResult.status
    // new_array['secondTeamName']= explode[1];
    new_array["marketId"] = data.marketBook.marketId;
    new_array["teamOneFirstBack"] =
      data.marketBook.runners[0].ex.availableToBack[0].price;
    new_array["teamOneFirstBackSize"] =
      data.marketBook.runners[0].ex.availableToBack[0].size;
    // 	if(getResult.runners!=undefined){

    // 	if(getResult.runners[0]!=undefined){
    // 		new_array['teamOneSelectionId']=   getResult.runners[0].selectionId;
    // 		if(getResult.runners[0].ex.availableToBack[0]!=undefined){

    new_array["firstTeamName"] = data.marketBook.runners[0].runnerName;
    new_array["secondTeamName"] = data.marketBook.runners[1].runnerName;
    if (
      this.state.teamOneFirstBack !==
      data.marketBook.runners[0].ex.availableToBack[0].price
    ) {
      $("#blockin1").css("transition", "1s");
      $("#blockin1").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin1").css("background", "#b2d6f0");
      }, 400);
    }

    if (
      this.state.teamOneFirstBackSize !==
      data.marketBook.runners[0].ex.availableToBack[0].size
    ) {
      $("#blockin1").css("transition", "1s");
      $("#blockin1").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin1").css("background", "#b2d6f0");
      }, 400);
    }
    new_array["teamOneMiddleBack"] =
      data.marketBook.runners[0].ex.availableToBack[1].price;
    if (
      this.state.teamOneMiddleBack !==
      data.marketBook.runners[0].ex.availableToBack[1].price
    ) {
      $("#blockin2").css("transition", "1s");
      $("#blockin2").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin2").css("background", "#92c9f0");
      }, 400);
    }

    new_array["teamOneMiddleBackSize"] =
      data.marketBook.runners[0].ex.availableToBack[1].size;

    if (
      this.state.teamOneMiddleBackSize !==
      data.marketBook.runners[0].ex.availableToBack[1].size
    ) {
      $("#blockin2").css("transition", "1s");
      $("#blockin2").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin2").css("background", "#92c9f0");
      }, 400);
    }

    new_array["teamOneLastBack"] =
      data.marketBook.runners[0].ex.availableToBack[2].price;
    if (
      this.state.teamOneLastBack !==
      data.marketBook.runners[0].ex.availableToBack[2].price
    ) {
      $("#blockin3").css("transition", "1s");
      $("#blockin3").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin3").css("background", "#72bbef");
      }, 400);
    }

    new_array["teamOneLastBackSize"] =
      data.marketBook.runners[0].ex.availableToBack[2].size;

    if (
      this.state.teamOneLastBackSize !==
      data.marketBook.runners[0].ex.availableToBack[2].size
    ) {
      $("#blockin3").css("transition", "1s");
      $("#blockin3").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin3").css("background", "#72bbef");
      }, 400);
    }
    new_array["teamOneFirstLay"] =
      data.marketBook.runners[0].ex.availableToLay[0].price;

    if (
      this.state.teamOneFirstLay !==
      data.marketBook.runners[0].ex.availableToLay[0].price
    ) {
      $("#blockin4").css("transition", "1s");
      $("#blockin4").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin4").css("background", "#faa9ba");
      }, 400);
    }

    new_array["teamOneFirstLaySize"] =
      data.marketBook.runners[0].ex.availableToLay[0].size;
    if (
      this.state.teamOneFirstLaySize !==
      data.marketBook.runners[0].ex.availableToLay[0].size
    ) {
      $("#blockin4").css("transition", "1s");
      $("#blockin4").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin4").css("background", "#faa9ba");
      }, 400);
    }

    new_array["teamOneMiddleLay"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[1] &&
      data.marketBook.runners[0].ex.availableToLay[1].price;

    if (
      this.state.teamOneMiddleLay !==
      (data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[0] &&
        data.marketBook.runners[0].ex &&
        data.marketBook.runners[0].ex.availableToLay &&
        data.marketBook.runners[0].ex.availableToLay[1] &&
        data.marketBook.runners[0].ex.availableToLay[1].price)
    ) {
      $("#blockin5").css("transition", "1s");
      $("#blockin5").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin5").css("background", "#f8bbc8");
      }, 400);
    }

    new_array["teamOneMiddleLaySize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[1] &&
      data.marketBook.runners[0].ex.availableToLay[1].size;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[1] &&
      data.marketBook.runners[0].ex.availableToLay[1].size &&
      this.state.teamOneMiddleLay !==
        data.marketBook.runners[0].ex.availableToLay[1].size
    ) {
      $("#blockin5").css("transition", "1s");
      $("#blockin5").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin5").css("background", "#f8bbc8");
      }, 400);
    }
    new_array["teamOneLastLay"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[2] &&
      data.marketBook.runners[0].ex.availableToLay[2].price;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[2] &&
      data.marketBook.runners[0].ex.availableToLay[2].price &&
      this.state.teamOneLastLay !==
        data.marketBook.runners[0].ex.availableToLay[2].price
    ) {
      $("#blockin6").css("transition", "1s");
      $("#blockin6").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin6").css("background", "#f6cdd6");
      }, 400);
    }

    new_array["teamOneLastLaySize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[2] &&
      data.marketBook.runners[0].ex.availableToLay[2].size;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[0] &&
      data.marketBook.runners[0].ex &&
      data.marketBook.runners[0].ex.availableToLay &&
      data.marketBook.runners[0].ex.availableToLay[2] &&
      data.marketBook.runners[0].ex.availableToLay[2].size &&
      this.state.teamOneLastLaySize !==
        data.marketBook.runners[0].ex.availableToLay[2].size
    ) {
      $("#blockin6").css("transition", "1s");
      $("#blockin6").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin6").css("background", "#f6cdd6");
      }, 400);
    }

    // 	new_array['teamTwoSelectionId']=  getResult.runners[1].selectionId;
    // 	if(getResult.runners[1].ex.availableToBack[0]!=undefined){
    new_array["teamTwoFirstBack"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[0] &&
      data.marketBook.runners[1].ex.availableToBack[0].price;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[0] &&
      data.marketBook.runners[1].ex.availableToBack[0].price &&
      this.state.teamTwoFirstBack !==
        data.marketBook.runners[1].ex.availableToBack[0].price
    ) {
      $("#blockin7").css("transition", "1s");
      $("#blockin7").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin7").css("background", "#b2d6f0");
      }, 400);
    }
    new_array["teamTwoFirstBackSize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[0] &&
      data.marketBook.runners[1].ex.availableToBack[0].size;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[0] &&
      data.marketBook.runners[1].ex.availableToBack[0].size &&
      this.state.teamTwoFirstBackSize !==
        data.marketBook.runners[1].ex.availableToBack[0].size
    ) {
      $("#blockin7").css("transition", "1s");
      $("#blockin7").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin7").css("background", "#b2d6f0");
      }, 400);
    }
    new_array["teamTwoMiddleBack"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[1] &&
      data.marketBook.runners[1].ex.availableToBack[1].price;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[1] &&
      data.marketBook.runners[1].ex.availableToBack[1].price &&
      this.state.teamTwoMiddleBack !==
        data.marketBook.runners[1].ex.availableToBack[1].price
    ) {
      $("#blockin8").css("transition", "1s");
      $("#blockin8").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin8").css("background", "#92c9f0");
      }, 400);
    }

    new_array["teamTwoMiddleBackSize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[1] &&
      data.marketBook.runners[1].ex.availableToBack[1].size;

    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[1] &&
      data.marketBook.runners[1].ex.availableToBack[1].size &&
      this.state.teamTwoMiddleBackSize !==
        data.marketBook.runners[1].ex.availableToBack[1].size
    ) {
      $("#blockin8").css("transition", "1s");
      $("#blockin8").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin8").css("background", "#92c9f0");
      }, 400);
    }

    new_array["teamTwoLastBack"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[2] &&
      data.marketBook.runners[1].ex.availableToBack[2].price;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[2] &&
      data.marketBook.runners[1].ex.availableToBack[2].price &&
      this.state.teamTwoLastBack !==
        data.marketBook.runners[1].ex.availableToBack[2].price
    ) {
      $("#blockin9").css("transition", "1s");
      $("#blockin9").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin9").css("background", "#72bbef");
      }, 400);
    }

    new_array["teamTwoLastBackSize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[2] &&
      data.marketBook.runners[1].ex.availableToBack[2].size;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToBack &&
      data.marketBook.runners[1].ex.availableToBack[2] &&
      data.marketBook.runners[1].ex.availableToBack[2].size &&
      this.state.teamTwoLastBackSize !==
        data.marketBook.runners[1].ex.availableToBack[2].size
    ) {
      $("#blockin9").css("transition", "1s");
      $("#blockin9").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin9").css("background", "#72bbef");
      }, 400);
    }
    new_array["teamTwoFirstLay"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[0] &&
      data.marketBook.runners[1].ex.availableToLay[0].price;
    if (
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[0] &&
      data.marketBook.runners[1].ex.availableToLay[0].price &&
      this.state.teamTwoFirstLay !==
        data.marketBook.runners[1].ex.availableToLay[0].price
    ) {
      $("#blockin10").css("transition", "1s");
      $("#blockin10").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin10").css("background", "#faa9ba");
      }, 400);
    }

    new_array["teamTwoFirstLaySize"] =
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[0] &&
      data.marketBook.runners[1].ex.availableToLay[0].size;
    if (
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[0] &&
      data.marketBook.runners[1].ex.availableToLay[0].size &&
      this.state.teamTwoFirstLaySize !==
        data.marketBook.runners[1].ex.availableToLay[0].size
    ) {
      $("#blockin10").css("transition", "1s");
      $("#blockin10").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin10").css("background", "#faa9ba");
      }, 400);
    }
    new_array["teamTwoMiddleLay"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[1] &&
      data.marketBook.runners[1].ex.availableToLay[1].price;
    if (
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[1] &&
      data.marketBook.runners[1].ex.availableToLay[1].price &&
      this.state.teamTwoMiddleLay !==
        data.marketBook.runners[1].ex.availableToLay[1].price
    ) {
      $("#blockin11").css("transition", "1s");
      $("#blockin11").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin11").css("background", "#f8bbc8");
      }, 400);
    }
    new_array["teamTwoMiddleLaySize"] =
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[1] &&
      data.marketBook.runners[1].ex.availableToLay[1].price;

    if (
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[1] &&
      data.marketBook.runners[1].ex.availableToLay[1].price &&
      this.state.teamTwoFirstLaySize !==
        data.marketBook.runners[1].ex.availableToLay[1].price
    ) {
      $("#blockin11").css("transition", "1s");
      $("#blockin11").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin11").css("background", "#f8bbc8");
      }, 400);
    }
    new_array["teamTwoLastLay"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[2] &&
      data.marketBook.runners[1].ex.availableToLay[2].price;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[2] &&
      data.marketBook.runners[1].ex.availableToLay[2].price &&
      this.state.teamTwoLastLay !==
        data.marketBook.runners[1].ex.availableToLay[2].price
    ) {
      $("#blockin12").css("transition", "1s");
      $("#blockin12").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin12").css("background", "#f6cdd6");
      }, 400);
    }
    new_array["teamTwoLastLaySize"] =
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[2] &&
      data.marketBook.runners[1].ex.availableToLay[2].size;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[1] &&
      data.marketBook.runners[1].ex &&
      data.marketBook.runners[1].ex.availableToLay &&
      data.marketBook.runners[1].ex.availableToLay[2] &&
      data.marketBook.runners[1].ex.availableToLay[2].size &&
      this.state.teamTwoLastLaySize !==
        data.marketBook.runners[1].ex.availableToLay[2].size
    ) {
      $("#blockin12").css("transition", "1s");
      $("#blockin12").css("background", "#ffc107");
      setTimeout(function () {
        $("#blockin12").css("background", "#f6cdd6");
      }, 400);
    }

    // 	}

    // 	if(getResult.runners[2]!=undefined){
    // 	new_array['draw']= true,

    //new_array['drawSelectionId']= getResult.runners[2].selectionId;
    if (
      data &&
      data.marketBook &&
      data.marketBook.runners &&
      data.marketBook.runners[2] &&
      data.marketBook.runners[2] !== undefined
    ) {
      new_array["draw"] = true;
      new_array["drawTeamName"] = "The Draw";
      new_array["drawFirstBack"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[0] &&
        data.marketBook.runners[2].ex.availableToBack[0].price &&
        data.marketBook.runners[2].ex.availableToBack[0].price;
      new_array["drawFirstBackSize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[0] &&
        data.marketBook.runners[2].ex.availableToBack[0].size;

      new_array["drawMiddleBack"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[1] &&
        data.marketBook.runners[2].ex.availableToBack[1].price;
      new_array["drawMiddleBackSize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[1] &&
        data.marketBook.runners[2].ex.availableToBack[1].size;

      new_array["drawLastBack"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[2] &&
        data.marketBook.runners[2].ex.availableToBack[2].price;
      new_array["drawLastBackSize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[2] &&
        data.marketBook.runners[2].ex.availableToBack[2].size;

      new_array["drawFirstLay"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToBack &&
        data.marketBook.runners[2].ex.availableToBack[0] &&
        data.marketBook.runners[2].ex.availableToBack[0].price;
      new_array["drawFirstLaySize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToLay &&
        data.marketBook.runners[2].ex.availableToLay[0] &&
        data.marketBook.runners[2].ex.availableToLay[0].size;

      new_array["drawMiddleLay"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToLay &&
        data.marketBook.runners[2].ex.availableToLay[1] &&
        data.marketBook.runners[2].ex.availableToLay[1].price;
      new_array["drawMiddleLaySize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToLay &&
        data.marketBook.runners[2].ex.availableToLay[1] &&
        data.marketBook.runners[2].ex.availableToLay[1].size;

      new_array["drawLastLay"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToLay &&
        data.marketBook.runners[2].ex.availableToLay[2] &&
        data.marketBook.runners[2].ex.availableToBack[2].price;
      new_array["drawLastLaySize"] =
        data &&
        data.marketBook &&
        data.marketBook.runners &&
        data.marketBook.runners[2] &&
        data.marketBook.runners[2].ex &&
        data.marketBook.runners[2].ex.availableToLay &&
        data.marketBook.runners[2].ex.availableToLay[2] &&
        data.marketBook.runners[2].ex.availableToBack[2].size;
    }

    // 	new_array['status']=  getResult.status

    // if (data.bookmake[0].runners != undefined) {
    //   new_array["bookmakerFirstTeamFound"] = true;
    //   var backPrice1 = 0;
    //   if (
    //     data.bookmake[0].runners[0].BackPrice1 != 0 &&
    //     data.bookmake[0].runners[0].BackPrice1 != undefined
    //   ) {
    //     backPrice1 = data.bookmake[0].runners[0].BackPrice1.split(".");
    //     if (backPrice1 != undefined && backPrice1 != 0) {
    //       backPrice1 = backPrice1[1];
    //     }
    //   }
    //   var backPrice2 = 0;
    //   if (
    //     data.bookmake[0].runners[0].BackPrice2 != 0 &&
    //     data.bookmake[0].runners[0].BackPrice2 != undefined
    //   ) {
    //     backPrice2 = data.bookmake[0].runners[0].BackPrice2.split(".");
    //     if (backPrice2 != undefined && backPrice2 != 0) {
    //       backPrice2 = backPrice2[1];
    //     }
    //   }
    //   var backPrice3 = 0;
    //   if (
    //     data.bookmake[0].runners[0].BackPrice3 != 0 &&
    //     data.bookmake[0].runners[0].BackPrice3 != undefined
    //   ) {
    //     backPrice3 = data.bookmake[0].runners[0].BackPrice3.split(".");
    //     if (backPrice3 != undefined && backPrice3 != 0) {
    //       backPrice3 = backPrice3[1];
    //     }
    //   }
    //   var layPrice1 = 0;
    //   if (
    //     data.bookmake[0].runners[0].LayPrice1 != 0 &&
    //     data.bookmake[0].runners[0].LayPrice1 != undefined
    //   ) {
    //     layPrice1 = data.bookmake[0].runners[0].LayPrice1.split(".");
    //     if (layPrice1 != undefined && layPrice1 != 0) {
    //       layPrice1 = layPrice1[1];
    //     }
    //   }

    //   var layPrice2 = 0;
    //   if (
    //     data.bookmake[0].runners[0].LayPrice2 != 0 &&
    //     data.bookmake[0].runners[0].LayPrice2 != undefined
    //   ) {
    //     layPrice2 = data.bookmake[0].runners[0].LayPrice2.split(".");
    //     if (layPrice2 != undefined && layPrice2 != 0) {
    //       layPrice2 = layPrice1[1];
    //     }
    //   }

    //   var layPrice3 = 0;

    //   if (
    //     data.bookmake[0].runners[0].layPrice3 != 0 &&
    //     data.bookmake[0].runners[0].layPrice3 != undefined
    //   ) {
    //     layPrice3 = data.bookmake[0].runners[0].layPrice3.split(".");
    //     if (layPrice3 != undefined && layPrice3 != 0) {
    //       layPrice3 = layPrice3[1];
    //     }
    //   }

    //   //new_array['bookmaker_team_a']=       bookmaker[i].nat;
    //   new_array["bookmaker_a_back_1"] = backPrice1;
    //   new_array["bookmaker_a_back_2"] = backPrice2;
    //   new_array["bookmaker_a_back_3"] = backPrice3;
    //   new_array["bookmaker_a_lay_1"] = layPrice1;
    //   new_array["bookmaker_a_lay_2"] = layPrice2;
    //   new_array["bookmaker_a_lay_3"] = layPrice3;
    //   //new_array['bookmaker_a_status']     	=bookmaker[i].s;
    //   new_array["bookmaker_a_back_4"] = data.bookmake[0].runners[0].BackSize1;
    //   new_array["bookmaker_a_back_5"] = data.bookmake[0].runners[0].BackSize2;
    //   new_array["bookmaker_a_back_6"] = data.bookmake[0].runners[0].BackSize3;
    //   new_array["bookmaker_a_lay_4"] = data.bookmake[0].runners[0].LaySize1;
    //   new_array["bookmaker_a_lay_5"] = data.bookmake[0].runners[0].LaySize2;
    //   new_array["bookmaker_a_lay_6"] = data.bookmake[0].runners[0].LaySize3;
    // }

    // if (data.bookmake[0].runners != undefined) {
    //   if (data.bookmake[0].runners[1] != undefined) {
    //     new_array["bookmakerSecondTeamFound"] = true;
    //     // new_array['min_bookmaker']=bookmaker[i].min;
    //     // new_array['max_bookmaker']=bookmaker[i].max;
    //     // new_array['bookmaker_team_b']=bookmaker[i].nat;
    //     // new_array['bookmaker_b_back_1']=bookmaker[i].b1;
    //     // new_array['bookmaker_b_back_4']=this.fnum(bookmaker[i].bs1);
    //     // new_array['bookmaker_b_back_2']=bookmaker[i].b2;
    //     // new_array['bookmaker_b_back_5']=this.fnum(bookmaker[i].bs2);
    //     // new_array['bookmaker_b_back_3']=bookmaker[i].b3;
    //     // new_array['bookmaker_b_back_6']=this.fnum(bookmaker[i].bs3);
    //     // new_array['bookmaker_b_lay_1']=bookmaker[i].l1;
    //     // new_array['bookmaker_b_lay_2']=bookmaker[i].l2;
    //     // new_array['bookmaker_b_lay_3']=bookmaker[i].l3;
    //     // new_array['bookmaker_b_lay_4']=this.fnum(bookmaker[i].ls1);
    //     // new_array['bookmaker_b_lay_5']=this.fnum(bookmaker[i].ls2);
    //     // new_array['bookmaker_b_lay_6']=this.fnum(bookmaker[i].ls3);
    //     // new_array['bookmaker_b_status']=bookmaker[i].s;
    //     var backPrice44 = 0;
    //     if (
    //       data.bookmake[0].runners[1].BackPrice1 != 0 &&
    //       data.bookmake[0].runners[1].BackPrice1 != undefined
    //     ) {
    //       backPrice44 = data.bookmake[0].runners[1].BackPrice1.split(".");
    //       if (backPrice44 != undefined && backPrice44 != 0) {
    //         backPrice44 = backPrice44[1];
    //       }
    //     }
    //     var backPrice45 = 0;
    //     if (
    //       data.bookmake[0].runners[0].BackPrice2 != 0 &&
    //       data.bookmake[0].runners[1].BackPrice2 != undefined
    //     ) {
    //       backPrice45 = data.bookmake[0].runners[1].BackPrice2.split(".");
    //       if (backPrice45 != undefined && backPrice45 != 0) {
    //         backPrice45 = backPrice45[1];
    //       }
    //     }

    //     var backPrice46 = 0;
    //     if (
    //       data.bookmake[0].runners[0].BackPrice3 != 0 &&
    //       data.bookmake[0].runners[1].BackPrice3 != undefined
    //     ) {
    //       backPrice46 = data.bookmake[0].runners[1].BackPrice3.split(".");
    //       if (backPrice46 != undefined && backPrice46 != 0) {
    //         backPrice46 = backPrice46[1];
    //       }
    //     }
    //     var layPrice44 = 0;

    //     if (
    //       data.bookmake[0].runners[0].LayPrice1 != 0 &&
    //       data.bookmake[0].runners[1].LayPrice1 != undefined
    //     ) {
    //       layPrice44 = data.bookmake[0].runners[1].LayPrice1.split(".");
    //       if (layPrice44 != undefined && layPrice44 != 0) {
    //         layPrice44 = layPrice44[1];
    //       }
    //     }

    //     var layPrice45 = 0;
    //     if (
    //       data.bookmake[0].runners[0].LayPrice2 != 0 &&
    //       data.bookmake[0].runners[1].LayPrice2 != undefined
    //     ) {
    //       layPrice45 = data.bookmake[0].runners[1].LayPrice2.split(".");
    //       if (layPrice45 != undefined && layPrice45 != 0) {
    //         layPrice45 = layPrice45[1];
    //       }
    //     }

    //     var layPrice46 = 0;
    //     if (
    //       data.bookmake[0].runners[0].layPrice3 != 0 &&
    //       data.bookmake[0].runners[1].layPrice3 != undefined
    //     ) {
    //       layPrice46 = data.bookmake[0].runners[1].layPrice3.split(".");
    //       if (layPrice46 != undefined && layPrice46 != 0) {
    //         layPrice46 = layPrice46[1];
    //       }
    //     }

    //     new_array["bookmaker_b_back_1"] =
    //       data.bookmake[0].runners[1].BackPrice1;
    //     new_array["bookmaker_b_back_2"] =
    //       data.bookmake[0].runners[1].BackPrice2;
    //     new_array["bookmaker_b_back_3"] =
    //       data.bookmake[0].runners[1].BackPrice3;
    //     new_array["bookmaker_b_lay_1"] = data.bookmake[0].runners[1].LayPrice1;
    //     new_array["bookmaker_b_lay_2"] = data.bookmake[0].runners[1].LayPrice2;
    //     new_array["bookmaker_b_lay_3"] = data.bookmake[0].runners[1].LayPrice3;
    //     new_array["bookmaker_b_back_4"] = data.bookmake[0].runners[1].BackSize1;
    //     new_array["bookmaker_b_back_5"] = data.bookmake[0].runners[1].BackSize2;
    //     new_array["bookmaker_b_back_6"] = data.bookmake[0].runners[1].BackSize3;
    //     new_array["bookmaker_b_lay_4"] = data.bookmake[0].runners[1].LaySize1;
    //     new_array["bookmaker_b_lay_5"] = data.bookmake[0].runners[1].LaySize2;
    //     new_array["bookmaker_b_lay_6"] = data.bookmake[0].runners[1].LaySize3;
    //   }
    // }
    // if (data.bookmake[0].runners != undefined) {
    //   if (data.bookmake[0].runners[2] != undefined) {
    //     var backPrice47 = 0;
    //     if (
    //       data.bookmake[0].runners[1].BackPrice1 != 0 &&
    //       data.bookmake[0].runners[2].BackPrice1 != undefined
    //     ) {
    //       backPrice47 = data.bookmake[0].runners[2].BackPrice1.split(".");
    //       if (backPrice47 != undefined && backPrice47 != 0) {
    //         backPrice47 = backPrice47[1];
    //       }
    //     }
    //     var backPrice48 = 0;
    //     if (
    //       data.bookmake[0].runners[0].BackPrice2 != 0 &&
    //       data.bookmake[0].runners[2].BackPrice2 != undefined
    //     ) {
    //       backPrice48 = data.bookmake[0].runners[2].BackPrice2.split(".");
    //       if (backPrice48 != undefined && backPrice48 != 0) {
    //         backPrice48 = backPrice48[1];
    //       }
    //     }

    //     var backPrice49 = 0;
    //     if (
    //       data.bookmake[0].runners[0].BackPrice3 != 0 &&
    //       data.bookmake[0].runners[2].BackPrice3 != undefined
    //     ) {
    //       backPrice49 = data.bookmake[0].runners[2].BackPrice3.split(".");
    //       if (backPrice49 != undefined && backPrice49 != 0) {
    //         backPrice49 = backPrice49[1];
    //       }
    //     }
    //     var layPrice47 = 0;
    //     if (
    //       data.bookmake[0].runners[0].LayPrice1 != 0 &&
    //       data.bookmake[0].runners[2].LayPrice1 != undefined
    //     ) {
    //       layPrice47 = data.bookmake[0].runners[2].LayPrice1.split(".");
    //       if (layPrice47 != undefined && layPrice47 != 0) {
    //         layPrice47 = layPrice47[1];
    //       }
    //     }

    //     var layPrice48 = 0;
    //     if (
    //       data.bookmake[0].runners[0].LayPrice2 != 0 &&
    //       data.bookmake[0].runners[2].LayPrice2 != undefined
    //     ) {
    //       layPrice48 = data.bookmake[0].runners[2].LayPrice2.split(".");
    //       if (layPrice48 != undefined && layPrice48 != 0) {
    //         layPrice48 = layPrice1[1];
    //       }
    //     }

    //     var layPrice49 = 0;
    //     if (
    //       data.bookmake[0].runners[0].layPrice3 != 0 &&
    //       data.bookmake[0].runners[2].layPrice3 != undefined
    //     ) {
    //       layPrice49 = data.bookmake[0].runners[2].layPrice3.split(".");
    //       if (layPrice49 != undefined && layPrice49 != 0) {
    //         layPrice49 = layPrice1[1];
    //       }
    //     }

    //     new_array["bookmaker_c_back_1"] = backPrice47;
    //     new_array["bookmaker_c_back_2"] = backPrice48;
    //     new_array["bookmaker_c_back_3"] = backPrice49;
    //     new_array["bookmaker_c_lay_1"] = data.bookmake[0].runners[2].LayPrice1;
    //     new_array["bookmaker_c_lay_2"] = data.bookmake[0].runners[2].LayPrice2;
    //     new_array["bookmaker_c_lay_3"] = data.bookmake[0].runners[2].LayPrice3;
    //     new_array["bookmaker_c_back_4"] = data.bookmake[0].runners[2].BackSize1;
    //     new_array["bookmaker_c_back_5"] = data.bookmake[0].runners[2].BackSize2;
    //     new_array["bookmaker_c_back_6"] = data.bookmake[0].runners[2].BackSize3;
    //     new_array["bookmaker_c_lay_4"] = layPrice47;
    //     new_array["bookmaker_c_lay_5"] = layPrice48;
    //     new_array["bookmaker_c_lay_6"] = layPrice49;
    //   }
    // }

    this.setState(new_array);
    this.setState({ sessiondata: data.session });
    //Fancy Api Data

    // 	this.setState({buttonvalue_new:buttonvalue_new});
    var teamOneSelectionId = this.state.teamOneSelectionId;
    var teamTwoSelectionId = this.state.teamTwoSelectionId;
    var profit12 = 0;
    var profit13 = 0;
    var profit14 = 0;
    var profit15 = 0;
    var profit17 = 0;
    var profit16 = 0;
    var NewProfit = 0;
    var NewProfit1 = 0;
    var NewProfit2 = 0;
    var new_array1 = [];
    var new_array2 = [];
    var new_array3 = [];
    var new_arrayfancy = [];
    var new_arrayfancy1 = [];
    var new_arrayfancy2 = [];
    var index = 0;
    ////////console.logthis.state.getResults);
    if (this.state.getResults != undefined) {
      ////console.logthis.state.getResults);

      for (let i = 0; i < this.state.getResults.length; i++) {
        if (
          this.state.getResults[i].profit_team == "teamone" &&
          this.state.getResults[i].team_name != "The Draw" &&
          this.state.getResults[i].bet_on === "odds"
        ) {
          if (this.state.getResults[i].bet_type != "lay") {
            profit12 =
              parseFloat(profit12) +
              parseFloat(this.state.getResults[i].profit);
          } else {
            var data123 = parseFloat(this.state.getResults[i].odds) - 1;
            var new_data =
              parseFloat(this.state.getResults[i].profit) * parseFloat(data123);
            NewProfit = new_data;
            profit12 = parseFloat(profit12) - parseFloat(NewProfit);
          }

          if (this.state.getResults[i].loss != undefined) {
            if (this.state.getResults[i].bet_type != "lay") {
              profit13 =
                parseFloat(profit13) -
                parseFloat(this.state.getResults[i].loss);
              profit14 =
                parseFloat(profit14) -
                parseFloat(this.state.getResults[i].loss);
            } else {
              profit13 =
                parseFloat(profit13) +
                parseFloat(this.state.getResults[i].loss);
              profit14 =
                parseFloat(profit14) +
                parseFloat(this.state.getResults[i].loss);
            }
          }
        } else if (
          this.state.getResults[i].profit_team == "teamtwo" &&
          this.state.getResults[i].team_name != "The Draw" &&
          this.state.getResults[i].bet_on === "odds"
        ) {
          if (this.state.getResults[i].bet_type != "lay") {
            profit13 =
              parseFloat(profit13) +
              parseFloat(this.state.getResults[i].profit);
          } else {
            var data124 =
              parseFloat(this.state.getResults[i].odds) - parseFloat(1);
            var new_data1 =
              parseFloat(this.state.getResults[i].profit) * parseFloat(data124);

            NewProfit1 = new_data1;
            profit13 = parseFloat(profit13) - parseFloat(NewProfit1);
          }

          if (this.state.getResults[i].loss != undefined) {
            if (this.state.getResults[i].bet_type != "lay") {
              profit12 =
                parseFloat(profit12) -
                parseFloat(this.state.getResults[i].loss);
              profit14 =
                parseFloat(profit14) -
                parseFloat(this.state.getResults[i].loss);
            } else {
              profit12 =
                parseFloat(profit12) +
                parseFloat(this.state.getResults[i].loss);
              profit14 =
                parseFloat(profit14) +
                parseFloat(this.state.getResults[i].loss);
            }
          }
        } else {
          if (this.state.getResults[i].bet_on === "odds") {
            if (this.state.getResults[i].bet_type != "lay") {
              profit14 =
                parseFloat(profit14) +
                parseFloat(this.state.getResults[i].profit);
            } else {
              var data125 =
                parseFloat(this.state.getResults[i].odds) - parseFloat(1);
              var new_data122 =
                parseFloat(this.state.getResults[i].profit) *
                parseFloat(data125);

              NewProfit2 = new_data122;
              profit14 = parseFloat(profit14) - NewProfit2;
            }

            if (this.state.getResults[i].loss != undefined) {
              if (this.state.getResults[i].bet_type != "lay") {
                profit12 =
                  parseFloat(profit12) -
                  parseFloat(this.state.getResults[i].stake);

                profit13 =
                  parseFloat(profit13) -
                  parseFloat(this.state.getResults[i].stake);
              } else {
                profit12 =
                  parseFloat(profit12) +
                  parseFloat(this.state.getResults[i].stake);
                profit13 =
                  parseFloat(profit13) +
                  parseFloat(this.state.getResults[i].stake);
              }
            }
          }
        }

        if (
          this.state.getResults[i].profit_team == "teamone" &&
          this.state.getResults[i].team_name != "The Draw" &&
          this.state.getResults[i].bet_on === "bookmaker"
        ) {
          if (this.state.getResults[i].bet_type != "lay") {
            profit15 =
              parseFloat(profit15) +
              parseFloat(this.state.getResults[i].profit);
          } else {
            var data123 = this.state.getResults[i].odds;
            if (Number.isInteger(parseFloat(data123)) == true) {
              var data123 = parseFloat(data123) / parseFloat(100);
            } else {
              var data123 =
                parseFloat(this.state.getResults[i].odds) - parseFloat(1);
            }

            var new_data =
              parseFloat(this.state.getResults[i].profit) * parseFloat(data123);
            NewProfit = new_data;
            profit15 = parseFloat(profit15) - parseFloat(NewProfit);
          }

          if (this.state.getResults[i].loss != undefined) {
            if (this.state.getResults[i].bet_type != "lay") {
              profit16 =
                parseFloat(profit16) -
                parseFloat(this.state.getResults[i].stake);
              profit17 =
                parseFloat(profit17) -
                parseFloat(this.state.getResults[i].stake);
            } else {
              profit16 =
                parseFloat(profit16) +
                parseFloat(this.state.getResults[i].stake);
              profit17 =
                parseFloat(profit17) +
                parseFloat(this.state.getResults[i].stake);
            }
          }
        } else if (
          this.state.getResults[i].profit_team == "teamtwo" &&
          this.state.getResults[i].team_name != "The Draw" &&
          this.state.getResults[i].bet_on === "bookmaker"
        ) {
          //console.logthis.state.getResults[i]);
          if (this.state.getResults[i].bet_type != "lay") {
            profit16 =
              parseFloat(profit16) +
              parseFloat(this.state.getResults[i].profit);
          } else {
            var data124 = this.state.getResults[i].odds;
            if (Number.isInteger(parseFloat(data124)) == true) {
              data124 = parseFloat(data124) / parseFloat(100);
            } else {
              var data124 =
                parseFloat(this.state.getResults[i].odds) - parseFloat(1);
            }
            var new_data1 =
              parseFloat(this.state.getResults[i].profit) * parseFloat(data124);

            NewProfit1 = new_data1;
            profit16 = parseFloat(profit16) - NewProfit1;
          }

          if (this.state.getResults[i].loss != undefined) {
            if (this.state.getResults[i].bet_type != "lay") {
              profit15 =
                parseFloat(profit15) -
                parseFloat(this.state.getResults[i].stake);
              profit17 =
                parseFloat(profit17) -
                parseFloat(this.state.getResults[i].stake);
            } else {
              profit15 =
                parseFloat(profit15) +
                parseFloat(this.state.getResults[i].stake);
              profit17 =
                parseFloat(profit17) +
                parseFloat(this.state.getResults[i].stake);
            }
          }
        } else {
          if (this.state.getResults[i].bet_on === "bookmaker") {
            if (this.state.getResults[i].bet_type != "lay") {
              profit17 =
                parseFloat(profit17) +
                parseFloat(this.state.getResults[i].profit);
            } else {
              var data125 = this.state.getResults[i].odds;
              if (Number.isInteger(parseFloat(data125)) == true) {
                data125 = parseFloat(data125) / parseFloat(100);
              } else {
                var data125 =
                  parseFloat(this.state.getResults[i].odds) - parseFloat(1);
              }

              var new_data122 =
                parseFloat(this.state.getResults[i].profit) *
                parseFloat(data125);

              NewProfit2 = new_data122;
              profit17 = parseFloat(profit17) - parseFloat(NewProfit2);
            }

            if (this.state.getResults[i].loss != undefined) {
              if (this.state.getResults[i].bet_type != "lay") {
                profit15 =
                  parseFloat(profit15) -
                  parseFloat(this.state.getResults[i].stake);

                profit16 =
                  parseFloat(profit16) -
                  parseFloat(this.state.getResults[i].stake);
              } else {
                profit15 =
                  parseFloat(profit15) +
                  parseFloat(this.state.getResults[i].stake);
                profit16 =
                  parseFloat(profit16) +
                  parseFloat(this.state.getResults[i].stake);
              }
            }
          }
        }

        if (this.state.getResults[i].bet_on == "fancy") {
          if (
            this.state.getResults[i].bet_on != null &&
            this.state.getResults[i].bet_on != undefined
          ) {
            new_arrayfancy.push(this.state.getResults[i].headname);
          }
        }
      }
    }

    this.setState({
      profit13: profit13.toFixed(2),
      profit12: profit12.toFixed(2),
      profit14: profit14.toFixed(2),
      profit15: profit15.toFixed(2),
      profit16: profit16.toFixed(2),
      profit17: profit17.toFixed(2),
      fancydata: new_arrayfancy,
      fancydata1: new_arrayfancy1,
      fancydata1: new_arrayfancy2,
    });
  };
  // callMatchOddsApi = (data) => {
  //   const { eventName } = this.state;
  //   let matchOdds =
  //     data &&
  //     data.market &&
  //     data.market.length &&
  //     data.market[0] &&
  //     data.market[0].events
  //       ? data.market[0] && data.market[0].events
  //       : null;
  //   this.setState({ matchOdds: matchOdds });
  //   let bookmaker =
  //     data.bookmake[0] && data.bookmake[0].runners
  //       ? data.bookmake[0].runners
  //       : null;
  //   this.setState({ matchOdds: matchOdds, bookmaker: bookmaker });

  //   if (
  //     data.session !== undefined &&
  //     data.session &&
  //     data.session[0] !== 'No Data'
  //   ) {
  //     // let myFancy = data.session.filter(item => item.GameStatus !== "OFFLINE" && item.GameStatus !== "CLOSED")
  //     this.setState({ sessiondata: data.session });
  //   }
  //   this.setState({
  //     eventName:
  //       data &&
  //       data.market &&
  //       data.market.length &&
  //       data.market[0] &&
  //       data.market[0].events &&
  //       data.market[0].events.length &&
  //       data.market[0].events[0] &&
  //       data.market[0].events[0].RunnerName
  //         ? data.market[0].events[0].RunnerName
  //         : null + ' v ' + data &&
  //           data.market[0] &&
  //           data.market[0].events[1] &&
  //           data.market[0].events[1].RunnerName
  //         ? data.market[0].events[1].RunnerName
  //         : null,
  //     marketId:
  //       data && data.market && data.market[0] && data.market[0].marketId
  //         ? data.market[0].marketId
  //         : null,
  //     firstTeamName:
  //       data.market &&
  //       data.market[0] &&
  //       data.market[0].events[0] &&
  //       data.market[0].events[0].RunnerName
  //         ? data.market[0].events[0].RunnerName
  //         : null,
  //     secondTeamName:
  //       data.market &&
  //       data.market[0] &&
  //       data.market[0].events[1] &&
  //       data.market[0].events[1].RunnerName
  //         ? data.market[0].events[1].RunnerName
  //         : null,
  //     teamOneSelectionId:
  //       data.market &&
  //       data.market[0] &&
  //       data.market[0].events[0] &&
  //       data.market[0].events[0].SelectionId
  //         ? data.market[0].events[0].SelectionId
  //         : 0,
  //     teamTwoSelectionId:
  //       data.market &&
  //       data.market[0] &&
  //       data.market[0].events[1] &&
  //       data.market[0].events[1].SelectionId
  //         ? data.market[0].events[1].SelectionId
  //         : 0,
  //   });

  //   if (
  //     data.market !== undefined ||
  //     (data.market && data.market.market !== 'no data')
  //   ) {
  //     if (data.market[0] && data.market[0].events[0] !== undefined) {
  //       this.setState({
  //         firstTeamName: matchOdds[0].RunnerName
  //           ? matchOdds[0].RunnerName
  //           : null,
  //         teamOneFirstBack: matchOdds[0].BackPrice1
  //           ? matchOdds[0].BackPrice1
  //           : 0,
  //         teamOneFirstBackSize: matchOdds[0].BackSize1
  //           ? matchOdds[0].BackSize1
  //           : 0,
  //         teamOneMiddleBack: matchOdds[0].BackPrice2
  //           ? matchOdds[0].BackPrice2
  //           : 0,
  //         teamOneMiddleBackSize: matchOdds[0].BackSize2
  //           ? matchOdds[0].BackSize2
  //           : 0,
  //         teamOneLastBack: matchOdds[0].BackPrice3
  //           ? matchOdds[0].BackPrice3
  //           : 0,
  //         teamOneLastBackSize: matchOdds[0].BackSize3
  //           ? matchOdds[0].BackSize3
  //           : 0,
  //         teamOneFirstLay: matchOdds[0].LayPrice1 ? matchOdds[0].LayPrice1 : 0,
  //         teamOneFirstLaySize: matchOdds[0].LaySize1
  //           ? matchOdds[0].LaySize1
  //           : 0,
  //         teamOneMiddleLay: matchOdds[0].LayPrice2 ? matchOdds[0].LayPrice2 : 0,
  //         teamOneMiddleLaySize: matchOdds[0].LaySize2
  //           ? matchOdds[0].LaySize2
  //           : 0,
  //         teamOneLastLay: matchOdds[0].LayPrice3 ? matchOdds[0].LayPrice3 : 0,
  //         teamOneLastLaySize: matchOdds[0].LaySize3 ? matchOdds[0].LaySize3 : 0,
  //       });
  //     }
  //     if (data.market[0] && data.market[0].events[1] !== undefined) {
  //       this.setState({
  //         secondTeamName: matchOdds[1].RunnerName
  //           ? matchOdds[1].RunnerName
  //           : null,
  //         teamTwoFirstBack: matchOdds[1].BackPrice1
  //           ? matchOdds[1].BackPrice1
  //           : 0,
  //         teamTwoFirstBackSize: matchOdds[1].BackSize1
  //           ? matchOdds[1].BackSize1
  //           : 0,
  //         teamTwoMiddleBack: matchOdds[1].BackPrice2
  //           ? matchOdds[1].BackPrice2
  //           : 0,
  //         teamTwoMiddleBackSize: matchOdds[1].BackSize2
  //           ? matchOdds[1].BackSize2
  //           : 0,
  //         teamTwoLastBack: matchOdds[1].BackPrice3
  //           ? matchOdds[1].BackPrice3
  //           : 0,
  //         teamTwoLastBackSize: matchOdds[1].BackSize3
  //           ? matchOdds[1].BackSize3
  //           : 0,
  //         teamTwoFirstLay: matchOdds[1].LayPrice1 ? matchOdds[1].LayPrice1 : 0,
  //         teamTwoFirstLaySize: matchOdds[1].LaySize1
  //           ? matchOdds[1].LaySize1
  //           : 0,
  //         teamTwoMiddleLay: matchOdds[1].LayPrice2 ? matchOdds[1].LayPrice2 : 0,
  //         teamTwoMiddleLaySize: matchOdds[1].LaySize2
  //           ? matchOdds[1].LaySize2
  //           : 0,
  //         teamTwoLastLay: matchOdds[1].LayPrice3 ? matchOdds[1].LayPrice3 : 0,
  //         teamTwoLastLaySize: matchOdds[1].LaySize3 ? matchOdds[1].LaySize3 : 0,
  //       });
  //     }
  //     if (data.market[0] && data.market[0].events[2] !== undefined) {
  //       this.setState({
  //         draw: true,
  //         drawTeamName: matchOdds[2].RunnerName
  //           ? matchOdds[2].RunnerName
  //           : null,
  //         drawFirstBack: matchOdds[2].BackPrice1 ? matchOdds[2].BackPrice1 : 0,
  //         drawFirstBackSize: matchOdds[2].BackSize1
  //           ? matchOdds[2].BackSize1
  //           : 0,
  //         drawMiddleBack: matchOdds[2].BackPrice2 ? matchOdds[2].BackPrice2 : 0,
  //         drawMiddleBackSize: matchOdds[2].BackSize2
  //           ? matchOdds[2].BackSize2
  //           : 0,
  //         drawLastBack: matchOdds[2].BackPrice3 ? matchOdds[2].BackPrice3 : 0,
  //         drawLastBackSize: matchOdds[2].BackSize3 ? matchOdds[2].BackSize3 : 0,
  //         drawFirstLay: matchOdds[2].LayPrice1 ? matchOdds[2].LayPrice1 : 0,
  //         drawFirstLaySize: matchOdds[2].LaySize1 ? matchOdds[2].LaySize1 : 0,
  //         drawMiddleLay: matchOdds[2].LayPrice2 ? matchOdds[2].LayPrice2 : 0,
  //         drawMiddleLaySize: matchOdds[2].LaySize2 ? matchOdds[2].LaySize2 : 0,
  //         drawLastLay: matchOdds[2].LayPrice3 ? matchOdds[2].LayPrice3 : 0,
  //         drawLastLaySize: matchOdds[2].LaySize3 ? matchOdds[2].LaySize3 : 0,
  //       });
  //     }
  //   }

  //   if (
  //     data.bookmake !== undefined &&
  //     data.bookmake[0] &&
  //     data.bookmake[0].runners &&
  //     data.bookmake[0].runners[0] !== 'unexpected Error Occur' &&
  //     data.bookmake[0].runners[0] !== 'No Data'
  //   ) {
  //     if (bookmaker[0] !== undefined) {
  //       this.setState({
  //         bookmakerFirstTeamFound: true,
  //         bookmaker_team1_status: bookmaker[0].GameStatus
  //           ? bookmaker[0].GameStatus
  //           : null,
  //         bookmaker_team1: bookmaker[0].RunnerName
  //           ? bookmaker[0].RunnerName
  //           : null,
  //         bookmaker_a_back_1:
  //           bookmaker[0] && bookmaker[0].BackPrice1
  //             ? bookmaker[0].BackPrice1
  //             : 0,
  //         bookmaker_a_back_2:
  //           bookmaker[0] && bookmaker[0].BackPrice2
  //             ? bookmaker[0].BackPrice2
  //             : 0,
  //         bookmaker_a_back_3:
  //           bookmaker[0] && bookmaker[0].BackPrice3
  //             ? bookmaker[0].BackPrice3
  //             : 0,
  //         bookmaker_a_lay_1:
  //           bookmaker[0] && bookmaker[0].LayPrice1 ? bookmaker[0].LayPrice1 : 0,
  //         bookmaker_a_lay_2:
  //           bookmaker[0] && bookmaker[0].LayPrice2 ? bookmaker[0].LayPrice2 : 0,
  //         bookmaker_a_lay_3:
  //           bookmaker[0] && bookmaker[0].LayPrice3 ? bookmaker[0].LayPrice3 : 0,
  //       });
  //     }
  //     if (bookmaker[1] !== undefined) {
  //       this.setState({
  //         bookmakerSecondTeamFound: true,
  //         bookmaker_team2_status: bookmaker[1].GameStatus
  //           ? bookmaker[1].GameStatus
  //           : null,
  //         bookmaker_team2: bookmaker[1].RunnerName
  //           ? bookmaker[1].RunnerName
  //           : null,
  //         bookmaker_b_back_1:
  //           bookmaker[1] && bookmaker[1].BackPrice1
  //             ? bookmaker[1].BackPrice1
  //             : 0,
  //         bookmaker_b_back_2:
  //           bookmaker[1] && bookmaker[1].BackPrice2
  //             ? bookmaker[1].BackPrice2
  //             : 0,
  //         bookmaker_b_back_3:
  //           bookmaker[1] && bookmaker[1].BackPrice3
  //             ? bookmaker[1].BackPrice3
  //             : 0,
  //         bookmaker_b_lay_1:
  //           bookmaker[1] && bookmaker[1].LayPrice1 ? bookmaker[1].LayPrice1 : 0,
  //         bookmaker_b_lay_2:
  //           bookmaker[1] && bookmaker[1].LayPrice2 ? bookmaker[1].LayPrice2 : 0,
  //         bookmaker_b_lay_3:
  //           bookmaker[1] && bookmaker[1].LayPrice3 ? bookmaker[1].LayPrice3 : 0,
  //       });
  //     }
  //     if (bookmaker[2] !== undefined) {
  //       this.setState({
  //         bookmaker_draw: true,
  //         bookmaker_team3_status: bookmaker[2].GameStatus
  //           ? bookmaker[2].GameStatus
  //           : null,
  //         bookmaker_team3: bookmaker[2].RunnerName
  //           ? bookmaker[2].RunnerName
  //           : null,
  //         bookmaker_d_back_1:
  //           bookmaker[2] && bookmaker[2].BackPrice1
  //             ? bookmaker[2].BackPrice1
  //             : 0,
  //         bookmaker_d_back_2:
  //           bookmaker[2] && bookmaker[2].BackPrice2
  //             ? bookmaker[2].BackPrice2
  //             : 0,
  //         bookmaker_d_back_3:
  //           bookmaker[2] && bookmaker[2].BackPrice3
  //             ? bookmaker[2].BackPrice3
  //             : 0,
  //         bookmaker_d_lay_1:
  //           bookmaker[2] && bookmaker[2].LayPrice1 ? bookmaker[2].LayPrice1 : 0,
  //         bookmaker_d_lay_2:
  //           bookmaker[2] && bookmaker[2].LayPrice2 ? bookmaker[2].LayPrice2 : 0,
  //         bookmaker_d_lay_3:
  //           bookmaker[2] && bookmaker[2].LayPrice3 ? bookmaker[2].LayPrice3 : 0,
  //       });
  //     }
  //   }

  //   if (this.state.teamOneFirstBack !== data.market[0].events[0].BackPrice1) {
  //     $('#blockin1').css('transition', '1s');
  //     $('#blockin1').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin1').css('background', '#b2d6f0');
  //     }, 400);
  //   }
  //   if (
  //     this.state.teamOneFirstBackSize !== data.market[0].events[0].BackSize1
  //   ) {
  //     $('#blockin1').css('transition', '1s');
  //     $('#blockin1').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin1').css('background', '#b2d6f0');
  //     }, 400);
  //   }
  //   if (this.state.teamOneMiddleBack !== data.market[0].events[0].BackPrice2) {
  //     $('#blockin2').css('transition', '1s');
  //     $('#blockin2').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin2').css('background', '#92c9f0');
  //     }, 400);
  //   }
  //   if (
  //     this.state.teamOneMiddleBackSize !== data.market[0].events[0].BackSize2
  //   ) {
  //     $('#blockin2').css('transition', '1s');
  //     $('#blockin2').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin2').css('background', '#92c9f0');
  //     }, 400);
  //   }
  //   if (this.state.teamOneLastBack !== data.market[0].events[0].BackPrice3) {
  //     $('#blockin3').css('transition', '1s');
  //     $('#blockin3').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin3').css('background', '#72bbef');
  //     }, 400);
  //   }

  //   if (this.state.teamOneLastBackSize !== data.market[0].events[0].BackSize3) {
  //     $('#blockin3').css('transition', '1s');
  //     $('#blockin3').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin3').css('background', '#72bbef');
  //     }, 400);
  //   }

  //   if (
  //     this.state.teamOneFirstLay !== data.market[0].events[0].LayPrice1 ||
  //     this.state.teamOneLastBack !== data.market[0].events[0].BackPrice3
  //   ) {
  //     $('#blockin4').css('transition', '1s');
  //     $('#blockin4').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin4').css('background', '#faa9ba');
  //     }, 400);
  //   }
  //   if (this.state.teamOneFirstLaySize !== data.market[0].events[0].LaySize1) {
  //     $('#blockin4').css('transition', '1s');
  //     $('#blockin4').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin4').css('background', '#faa9ba');
  //     }, 400);
  //   }

  //   if (this.state.teamOneMiddleLay !== data.market[0].events[0].LayPrice2) {
  //     $('#blockin5').css('transition', '1s');
  //     $('#blockin5').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin5').css('background', '#f8bbc8');
  //     }, 400);
  //   }

  //   if (this.state.teamOneMiddleLay !== data.market[0].events[0].LaySize2) {
  //     $('#blockin5').css('transition', '1s');
  //     $('#blockin5').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin5').css('background', '#f8bbc8');
  //     }, 400);
  //   }

  //   if (this.state.teamOneLastLay !== data.market[0].events[0].LayPrice3) {
  //     $('#blockin6').css('transition', '1s');
  //     $('#blockin6').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin6').css('background', '#f6cdd6');
  //     }, 400);
  //   }
  //   if (this.state.teamTwoFirstBack !== data.market[0].events[1].BackPrice1) {
  //     $('#blockin7').css('transition', '1s');
  //     $('#blockin7').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin7').css('background', '#b2d6f0');
  //     }, 400);
  //   }
  //   if (
  //     this.state.teamTwoFirstBackSize !== data.market[0].events[1].BackSize1
  //   ) {
  //     $('#blockin7').css('transition', '1s');
  //     $('#blockin7').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin7').css('background', '#b2d6f0');
  //     }, 400);
  //   }

  //   if (this.state.teamTwoMiddleBack !== data.market[0].events[1].BackPrice2) {
  //     $('#blockin8').css('transition', '1s');
  //     $('#blockin8').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin8').css('background', '#92c9f0');
  //     }, 400);
  //   }
  //   if (
  //     this.state.teamTwoMiddleBackSize !== data.market[0].events[1].BackSize2
  //   ) {
  //     $('#blockin8').css('transition', '1s');
  //     $('#blockin8').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin8').css('background', '#92c9f0');
  //     }, 400);
  //   }

  //   if (this.state.teamTwoLastBack !== data.market[0].events[1].BackPrice3) {
  //     $('#blockin9').css('transition', '1s');
  //     $('#blockin9').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin9').css('background', '#72bbef');
  //     }, 400);
  //   }
  //   if (this.state.teamTwoLastBackSize !== data.market[0].events[1].BackSize3) {
  //     $('#blockin9').css('transition', '1s');
  //     $('#blockin9').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin9').css('background', '#72bbef');
  //     }, 400);
  //   }

  //   this.state.teamTwoFirstLay = data.market[0].events[1].LayPrice1;
  //   if (this.state.teamTwoFirstLay !== data.market[0].events[1].LayPrice1) {
  //     $('#blockin10').css('transition', '1s');
  //     $('#blockin10').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin10').css('background', '#faa9ba');
  //     }, 400);
  //   }

  //   this.state.teamTwoFirstLaySize = data.market[0].events[1].LaySize1;
  //   if (this.state.teamTwoFirstLaySize !== data.market[0].events[1].LaySize1) {
  //     $('#blockin10').css('transition', '1s');
  //     $('#blockin10').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin10').css('background', '#faa9ba');
  //     }, 400);
  //   }
  //   this.state.teamTwoMiddleLay = data.market[0].events[1].LayPrice2;
  //   if (this.state.teamTwoMiddleLay !== data.market[0].events[1].LayPrice2) {
  //     $('#blockin11').css('transition', '1s');
  //     $('#blockin11').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin11').css('background', '#f8bbc8');
  //     }, 400);
  //   }
  //   this.state.teamTwoMiddleLaySize = data.market[0].events[1].LaySize2;

  //   if (this.state.teamTwoFirstLaySize !== data.market[0].events[1].LaySize2) {
  //     $('#blockin11').css('transition', '1s');
  //     $('#blockin11').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin11').css('background', '#f8bbc8');
  //     }, 400);
  //   }
  //   this.state.teamTwoLastLay = data.market[0].events[1].LayPrice3;
  //   if (this.state.teamTwoLastLay !== data.market[0].events[1].LayPrice3) {
  //     $('#blockin12').css('transition', '1s');
  //     $('#blockin12').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin12').css('background', '#f6cdd6');
  //     }, 400);
  //   }
  //   this.state.teamTwoLastLaySize = data.market[0].events[1].LaySize3;
  //   if (this.state.teamTwoLastLaySize !== data.market[0].events[1].LaySize3) {
  //     $('#blockin12').css('transition', '1s');
  //     $('#blockin12').css('background', '#ffc107');
  //     setTimeout(function () {
  //       $('#blockin12').css('background', '#f6cdd6');
  //     }, 400);
  //   }
  // };
  callBookmakerFromAdminApi = () => {
    let new_array = {};
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    let matchid = this.props.match.params.id;

    axios
      .get(baseUrl + "/getbookmarketbymatchid/" + matchid, { headers })
      .then((resp) => {
        var resp = resp.data;
        var showBookMakerLiveApiData = true;
        if (resp.success === true) {
          showBookMakerLiveApiData =
            resp.data.status === "enable" ? false : true;
          if (resp.data.status === "enable") {
            this.setState({
              bookMakerAdminDataFound: true,
              bookMakerAdminData: resp.data,
              max_bookmaker_limit: resp.data.max_bookmaker_limit,
              min_bookmaker_limit: resp.data.min_bookmaker_limit,
            });
          }
        }
        this.setState({ showBookMakerLiveApiData: showBookMakerLiveApiData });
      });
  };
  callBookmakerApi = (bookmaker = mockResdata.data.t2[0].bm1) => {
    if (this.state.showBookMakerLiveApiData === false) {
      return false;
    }
    let new_array = {};
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    let matchid = this.props.match.params.id;
    // axios.get(baseUrl + "/bookmaker/" + matchid, { headers }).then((resp) => {
    //   var bookmaker = resp.data.data;
    //   if (bookmaker !== undefined) {
    //     for (var i = 0; i < bookmaker.length; i++) {
    //       if (bookmaker[i].sid === 1) {
    //         new_array["bookmakerFirstTeamFound"] = true;
    //         new_array["bookmaker_team_a"] = bookmaker[i].nat;
    //         new_array["bookmaker_a_back_1"] = bookmaker[i].b1;
    //         new_array["bookmaker_a_back_2"] = bookmaker[i].b2;
    //         new_array["bookmaker_a_back_3"] = bookmaker[i].b3;
    //         new_array["bookmaker_a_lay_1"] = bookmaker[i].l1;
    //         new_array["bookmaker_a_lay_2"] = bookmaker[i].l2;
    //         new_array["bookmaker_a_lay_3"] = bookmaker[i].l3;
    //         new_array["bookmaker_a_status"] = bookmaker[i].s;
    //         new_array["bookmaker_a_back_4"] = this.fnum(bookmaker[i].bs1);
    //         new_array["bookmaker_a_back_5"] = this.fnum(bookmaker[i].bs2);
    //         new_array["bookmaker_a_back_6"] = this.fnum(bookmaker[i].bs3);
    //         new_array["bookmaker_a_lay_4"] = this.fnum(bookmaker[i].ls1);
    //         new_array["bookmaker_a_lay_5"] = this.fnum(bookmaker[i].ls2);
    //         new_array["bookmaker_a_lay_6"] = this.fnum(bookmaker[i].ls3);
    //       } else if (bookmaker[i].sid === 2) {
    //         new_array["bookmakerSecondTeamFound"] = true;
    //         new_array["min_bookmaker"] = bookmaker[i].min;
    //         new_array["max_bookmaker"] = bookmaker[i].max;
    //         new_array["bookmaker_team_b"] = bookmaker[i].nat;
    //         new_array["bookmaker_b_back_1"] = bookmaker[i].b1;
    //         new_array["bookmaker_b_back_4"] = this.fnum(bookmaker[i].bs1);
    //         new_array["bookmaker_b_back_2"] = bookmaker[i].b2;
    //         new_array["bookmaker_b_back_5"] = this.fnum(bookmaker[i].bs2);
    //         new_array["bookmaker_b_back_3"] = bookmaker[i].b3;
    //         new_array["bookmaker_b_back_6"] = this.fnum(bookmaker[i].bs3);
    //         new_array["bookmaker_b_lay_1"] = bookmaker[i].l1;
    //         new_array["bookmaker_b_lay_2"] = bookmaker[i].l2;
    //         new_array["bookmaker_b_lay_3"] = bookmaker[i].l3;
    //         new_array["bookmaker_b_lay_4"] = this.fnum(bookmaker[i].ls1);
    //         new_array["bookmaker_b_lay_5"] = this.fnum(bookmaker[i].ls2);
    //         new_array["bookmaker_b_lay_6"] = this.fnum(bookmaker[i].ls3);
    //         new_array["bookmaker_b_status"] = bookmaker[i].s;
    //       } else if (bookmaker[i].sid == 3) {
    //         new_array["bookmaker_draw"] = true;
    //         new_array["bookmaker_team_b"] = bookmaker[i].nat;
    //         new_array["bookmaker_d_back_1"] = bookmaker[i].b1;
    //         new_array["bookmaker_d_back_2"] = bookmaker[i].b2;
    //         new_array["bookmaker_d_back_3"] = bookmaker[i].b3;
    //         new_array["bookmaker_d_status"] = bookmaker[i].s;
    //         new_array["bookmaker_d_back_4"] = this.fnum(bookmaker[i].bs1);
    //         new_array["bookmaker_d_back_5"] = this.fnum(bookmaker[i].bs2);
    //         new_array["bookmaker_d_back_6"] = this.fnum(bookmaker[i].bs3);
    //         new_array["bookmaker_d_lay_1"] = bookmaker[i].l1;
    //         new_array["bookmaker_d_lay_2"] = bookmaker[i].l2;
    //         new_array["bookmaker_d_lay_3"] = bookmaker[i].l3;
    //         new_array["bookmaker_d_lay_4"] = this.fnum(bookmaker[i].ls1);
    //         new_array["bookmaker_d_lay_5"] = this.fnum(bookmaker[i].ls2);
    //         new_array["bookmaker_d_lay_6"] = this.fnum(bookmaker[i].ls3);
    //       }
    //     }
    //   }
    //   this.setState(new_array);
    //   if (bookmaker !== undefined) {
    //     if (bookmaker.t2 !== undefined) {
    //       if (bookmaker.t2[0] !== undefined && bookmaker.t2[0] != "") {
    //         for (var i = 0; i < bookmaker.t2[0].length; i++) {
    //           if (bookmaker.t2[0][i].sid === 1) {
    //             new_array["bookmakerFirstTeamFound"] = true;
    //             new_array["bookmaker_team_a"] = bookmaker.t2[0][i].nat;
    //             new_array["bookmaker_a_back_1"] = bookmaker.t2[0][i].b1;
    //             new_array["bookmaker_a_back_2"] = bookmaker.t2[0][i].b2;
    //             new_array["bookmaker_a_back_3"] = bookmaker.t2[0][i].b3;
    //             new_array["bookmaker_a_lay_1"] = bookmaker.t2[0][i].l1;
    //             new_array["bookmaker_a_lay_2"] = bookmaker.t2[0][i].l2;
    //             new_array["bookmaker_a_lay_3"] = bookmaker.t2[0][i].l3;
    //             new_array["bookmaker_a_status"] = bookmaker.t2[0][i].s;
    //             new_array["bookmaker_a_back_4"] = bookmaker.t2[0][i].bs1;
    //             new_array["bookmaker_a_back_5"] = bookmaker.t2[0][i].bs2;
    //             new_array["bookmaker_a_back_6"] = bookmaker.t2[0][i].bs3;
    //             new_array["bookmaker_a_lay_4"] = bookmaker.t2[0][i].ls1;
    //             new_array["bookmaker_a_lay_5"] = bookmaker.t2[0][i].ls2;
    //             new_array["bookmaker_a_lay_6"] = bookmaker.t2[0][i].ls3;
    //           } else if (bookmaker.t2[0][i].sid == 2) {
    //             new_array["bookmakerSecondTeamFound"] = true;
    //             new_array["min_bookmaker"] = bookmaker.t2[0][i].min;
    //             new_array["max_bookmaker"] = bookmaker.t2[0][i].max;
    //             new_array["bookmaker_team_a"] = bookmaker.t2[0][i].nat;
    //             new_array["bookmaker_b_back_1"] = bookmaker.t2[0][i].b1;
    //             new_array["bookmaker_b_back_4"] = bookmaker.t2[0][i].bs1;
    //             new_array["bookmaker_b_back_2"] = bookmaker.t2[0][i].b2;
    //             new_array["bookmaker_b_back_5"] = bookmaker.t2[0][i].bs2;
    //             new_array["bookmaker_b_back_3"] = bookmaker.t2[0][i].b3;
    //             new_array["bookmaker_b_back_6"] = bookmaker.t2[0][i].bs3;
    //             new_array["bookmaker_b_lay_1"] = bookmaker.t2[0][i].l1;
    //             new_array["bookmaker_b_lay_2"] = bookmaker.t2[0][i].l2;
    //             new_array["bookmaker_b_lay_3"] = bookmaker.t2[0][i].l3;
    //             new_array["bookmaker_b_lay_4"] = bookmaker.t2[0][i].ls1;
    //             new_array["bookmaker_b_lay_5"] = bookmaker.t2[0][i].ls2;
    //             new_array["bookmaker_b_lay_6"] = bookmaker.t2[0][i].ls3;
    //             new_array["bookmaker_b_status"] = bookmaker.t2[0][i].s;
    //           } else if (bookmaker.t2[0][i].sid == 3) {
    //             new_array["bookmaker_draw"] = true;
    //             new_array["bookmaker_team_b"] = bookmaker.t2[0][i].nat;
    //             new_array["bookmaker_d_back_1"] = bookmaker.t2[0][i].b1;
    //             new_array["bookmaker_d_back_2"] = bookmaker.t2[0][i].b2;
    //             new_array["bookmaker_d_back_3"] = bookmaker.t2[0][i].b3;
    //             new_array["bookmaker_d_status"] = bookmaker.t2[0][i].s;
    //             new_array["bookmaker_d_back_4"] = bookmaker.t2[0][i].bs1;
    //             new_array["bookmaker_d_back_5"] = bookmaker.t2[0][i].bs2;
    //             new_array["bookmaker_d_back_6"] = bookmaker.t2[0][i].bs3;
    //             new_array["bookmaker_d_lay_1"] = bookmaker.t2[0][i].l1;
    //             new_array["bookmaker_d_lay_2"] = bookmaker.t2[0][i].l2;
    //             new_array["bookmaker_d_lay_3"] = bookmaker.t2[0][i].l3;
    //             new_array["bookmaker_d_lay_4"] = bookmaker.t2[0][i].ls1;
    //             new_array["bookmaker_d_lay_5"] = bookmaker.t2[0][i].ls2;
    //             new_array["bookmaker_d_lay_6"] = bookmaker.t2[0][i].ls3;
    //           }
    //         }
    //       }
    //     }
    //   }
    // });
    // const ;
    if (bookmaker !== undefined) {
      for (var i = 0; i < bookmaker.length; i++) {
        console.log(bookmaker[i]);
        if (bookmaker[i].sid === "1") {
          new_array["bookmakerFirstTeamFound"] = true;
          new_array["bookmaker_team_a"] = bookmaker[i].nat;
          new_array["bookmaker_a_back_1"] = bookmaker[i].b1;
          new_array["bookmaker_a_back_2"] = bookmaker[i].b2;
          new_array["bookmaker_a_back_3"] = bookmaker[i].b3;
          new_array["bookmaker_a_lay_1"] = bookmaker[i].l1;
          new_array["bookmaker_a_lay_2"] = bookmaker[i].l2;
          new_array["bookmaker_a_lay_3"] = bookmaker[i].l3;
          new_array["bookmaker_a_status"] = bookmaker[i].s;
          new_array["bookmaker_a_back_4"] = this.fnum(bookmaker[i].bs1);
          new_array["bookmaker_a_back_5"] = this.fnum(bookmaker[i].bs2);
          new_array["bookmaker_a_back_6"] = this.fnum(bookmaker[i].bs3);
          new_array["bookmaker_a_lay_4"] = this.fnum(bookmaker[i].ls1);
          new_array["bookmaker_a_lay_5"] = this.fnum(bookmaker[i].ls2);
          new_array["bookmaker_a_lay_6"] = this.fnum(bookmaker[i].ls3);
        } else if (bookmaker[i].sid === "2") {
          new_array["bookmakerSecondTeamFound"] = true;
          new_array["min_bookmaker"] = bookmaker[i].min;
          new_array["max_bookmaker"] = bookmaker[i].max;
          new_array["bookmaker_team_b"] = bookmaker[i].nat;
          new_array["bookmaker_b_back_1"] = bookmaker[i].b1;
          new_array["bookmaker_b_back_4"] = this.fnum(bookmaker[i].bs1);
          new_array["bookmaker_b_back_2"] = bookmaker[i].b2;
          new_array["bookmaker_b_back_5"] = this.fnum(bookmaker[i].bs2);
          new_array["bookmaker_b_back_3"] = bookmaker[i].b3;
          new_array["bookmaker_b_back_6"] = this.fnum(bookmaker[i].bs3);
          new_array["bookmaker_b_lay_1"] = bookmaker[i].l1;
          new_array["bookmaker_b_lay_2"] = bookmaker[i].l2;
          new_array["bookmaker_b_lay_3"] = bookmaker[i].l3;
          new_array["bookmaker_b_lay_4"] = this.fnum(bookmaker[i].ls1);
          new_array["bookmaker_b_lay_5"] = this.fnum(bookmaker[i].ls2);
          new_array["bookmaker_b_lay_6"] = this.fnum(bookmaker[i].ls3);
          new_array["bookmaker_b_status"] = bookmaker[i].s;
        } else if (bookmaker[i].sid === "3") {
          new_array["bookmaker_draw"] = true;
          new_array["bookmaker_team_b"] = bookmaker[i].nat;
          new_array["bookmaker_d_back_1"] = bookmaker[i].b1;
          new_array["bookmaker_d_back_2"] = bookmaker[i].b2;
          new_array["bookmaker_d_back_3"] = bookmaker[i].b3;
          new_array["bookmaker_d_status"] = bookmaker[i].s;
          new_array["bookmaker_d_back_4"] = this.fnum(bookmaker[i].bs1);
          new_array["bookmaker_d_back_5"] = this.fnum(bookmaker[i].bs2);
          new_array["bookmaker_d_back_6"] = this.fnum(bookmaker[i].bs3);
          new_array["bookmaker_d_lay_1"] = bookmaker[i].l1;
          new_array["bookmaker_d_lay_2"] = bookmaker[i].l2;
          new_array["bookmaker_d_lay_3"] = bookmaker[i].l3;
          new_array["bookmaker_d_lay_4"] = this.fnum(bookmaker[i].ls1);
          new_array["bookmaker_d_lay_5"] = this.fnum(bookmaker[i].ls2);
          new_array["bookmaker_d_lay_6"] = this.fnum(bookmaker[i].ls3);
        }
      }
    }
    // console.log(new_array);
    this.setState(new_array);

    if (bookmaker !== undefined) {
      if (bookmaker.t2 !== undefined) {
        if (bookmaker.t2[0] !== undefined && bookmaker.t2[0] != "") {
          for (var i = 0; i < bookmaker.t2[0].length; i++) {
            if (bookmaker.t2[0][i].sid === 1) {
              new_array["bookmakerFirstTeamFound"] = true;
              new_array["bookmaker_team_a"] = bookmaker.t2[0][i].nat;
              new_array["bookmaker_a_back_1"] = bookmaker.t2[0][i].b1;
              new_array["bookmaker_a_back_2"] = bookmaker.t2[0][i].b2;
              new_array["bookmaker_a_back_3"] = bookmaker.t2[0][i].b3;
              new_array["bookmaker_a_lay_1"] = bookmaker.t2[0][i].l1;
              new_array["bookmaker_a_lay_2"] = bookmaker.t2[0][i].l2;
              new_array["bookmaker_a_lay_3"] = bookmaker.t2[0][i].l3;
              new_array["bookmaker_a_status"] = bookmaker.t2[0][i].s;
              new_array["bookmaker_a_back_4"] = bookmaker.t2[0][i].bs1;
              new_array["bookmaker_a_back_5"] = bookmaker.t2[0][i].bs2;
              new_array["bookmaker_a_back_6"] = bookmaker.t2[0][i].bs3;
              new_array["bookmaker_a_lay_4"] = bookmaker.t2[0][i].ls1;
              new_array["bookmaker_a_lay_5"] = bookmaker.t2[0][i].ls2;
              new_array["bookmaker_a_lay_6"] = bookmaker.t2[0][i].ls3;
            } else if (bookmaker.t2[0][i].sid == 2) {
              new_array["bookmakerSecondTeamFound"] = true;
              new_array["min_bookmaker"] = bookmaker.t2[0][i].min;
              new_array["max_bookmaker"] = bookmaker.t2[0][i].max;
              new_array["bookmaker_team_a"] = bookmaker.t2[0][i].nat;
              new_array["bookmaker_b_back_1"] = bookmaker.t2[0][i].b1;
              new_array["bookmaker_b_back_4"] = bookmaker.t2[0][i].bs1;
              new_array["bookmaker_b_back_2"] = bookmaker.t2[0][i].b2;
              new_array["bookmaker_b_back_5"] = bookmaker.t2[0][i].bs2;
              new_array["bookmaker_b_back_3"] = bookmaker.t2[0][i].b3;
              new_array["bookmaker_b_back_6"] = bookmaker.t2[0][i].bs3;
              new_array["bookmaker_b_lay_1"] = bookmaker.t2[0][i].l1;
              new_array["bookmaker_b_lay_2"] = bookmaker.t2[0][i].l2;
              new_array["bookmaker_b_lay_3"] = bookmaker.t2[0][i].l3;
              new_array["bookmaker_b_lay_4"] = bookmaker.t2[0][i].ls1;
              new_array["bookmaker_b_lay_5"] = bookmaker.t2[0][i].ls2;
              new_array["bookmaker_b_lay_6"] = bookmaker.t2[0][i].ls3;
              new_array["bookmaker_b_status"] = bookmaker.t2[0][i].s;
            } else if (bookmaker.t2[0][i].sid == 3) {
              new_array["bookmaker_draw"] = true;
              new_array["bookmaker_team_b"] = bookmaker.t2[0][i].nat;
              new_array["bookmaker_d_back_1"] = bookmaker.t2[0][i].b1;
              new_array["bookmaker_d_back_2"] = bookmaker.t2[0][i].b2;
              new_array["bookmaker_d_back_3"] = bookmaker.t2[0][i].b3;
              new_array["bookmaker_d_status"] = bookmaker.t2[0][i].s;
              new_array["bookmaker_d_back_4"] = bookmaker.t2[0][i].bs1;
              new_array["bookmaker_d_back_5"] = bookmaker.t2[0][i].bs2;
              new_array["bookmaker_d_back_6"] = bookmaker.t2[0][i].bs3;
              new_array["bookmaker_d_lay_1"] = bookmaker.t2[0][i].l1;
              new_array["bookmaker_d_lay_2"] = bookmaker.t2[0][i].l2;
              new_array["bookmaker_d_lay_3"] = bookmaker.t2[0][i].l3;
              new_array["bookmaker_d_lay_4"] = bookmaker.t2[0][i].ls1;
              new_array["bookmaker_d_lay_5"] = bookmaker.t2[0][i].ls2;
              new_array["bookmaker_d_lay_6"] = bookmaker.t2[0][i].ls3;
            }
          }
        }
      }
    }
  };

  showBookmakerAdmindataHtml = () => {
    if (this.state.bookMakerAdminDataFound === true) {
      var firstTeamSuspended =
        this.state.bookMakerAdminData.first_team_suspend === "true" ||
        this.state.bookmaker_team1_status === "SUSPEND"
          ? "bet-info suspended row"
          : "bet-info row";
      var returnHtml = [];

      returnHtml.push(
        <div className="row">
          <div className="col-6">
            Total Match: {this.state.twoteamtotalmatch}
          </div>
          <div className="col-1 box-w1">&nbsp;</div>
          <div className=" col-1 box-w1">&nbsp;</div>
          <div className="col-1 back box-w1">Back</div>
          <div className="col-1 lay box-w1">Lay</div>
          <div className="col-1 box-w1">&nbsp;</div>
          <div className="col-1 box-w1">&nbsp;</div>
        </div>
      );
      returnHtml.push(
        <div className={firstTeamSuspended}>
          <div className="team-name nation col-6 table-active" id="10301">
            <span>
              <strong>{this.state.firstTeamName}</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-right book"
                id="book_10301"
                style={{ color: "black" }}
              >
                {" "}
                {this.state.stackAmount_team2}
              </span>{" "}
              <span
                className="float-right profit"
                id="profit_10301"
                style={{ color: "black" }}
              ></span>
            </p>
            <p className="box-w4">
              <span
                className="float-left book"
                style={{ color: "black" }}
              ></span>{" "}
              <span
                className="float-left  profit"
                style={{ color: "black" }}
              ></span>
            </p>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#92C9F0" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>

          <div className="box-w1 back-color col-1">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClick.bind(
                this,
                this.state.firstTeamName,
                this.state.bookMakerAdminData.first_team_back,
                "#72bbef",
                "back",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "manual_bookmaker"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookMakerAdminData.first_team_back}
              </span>{" "}
            </button>
          </div>

          <div className="box-w1 lay-color col-1">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClick.bind(
                this,
                this.state.firstTeamName,
                this.state.bookMakerAdminData.first_team_lay,
                "#FAA9BA",
                "lay",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "manual_bookmaker"
              )}
            >
              <span className="odd layprice">
                {this.state.bookMakerAdminData.first_team_lay}
              </span>
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>
        </div>
      );

      var secondTeamSuspended =
        this.state.bookMakerAdminData.second_team_suspend === "true" ||
        this.state.bookmaker_team2_status === "SUSPEND"
          ? "bet-info suspended row"
          : "bet-info row";

      returnHtml.push(
        <div className={secondTeamSuspended}>
          <div className="team-name nation  table-active col-6">
            <span>
              <strong>{this.state.secondTeamName}</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-right book"
                id="book_349"
                style={{ color: "black" }}
              >
                {this.state.stackAmount_team1}
              </span>{" "}
              <span
                className="float-right profit"
                id="profit_349"
                style={{ color: "black" }}
              ></span>
            </p>

            <p className="box-w4">
              <span
                className="float-left book"
                style={{ color: "black" }}
              ></span>{" "}
              <span
                className="float-left  profit"
                style={{ color: "black" }}
              ></span>
            </p>
          </div>

          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {status}

            <span>&nbsp;</span>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#92C9F0" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>

          <div className="box-w1 back-color col-1">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClick.bind(
                this,
                this.state.secondTeamName,
                this.state.bookMakerAdminData.second_team_back,
                "#92C9F0",
                "back",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "manual_bookmaker"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookMakerAdminData.second_team_back}
              </span>
            </button>
          </div>

          <div className="box-w1 lay-color col-1">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClick.bind(
                this,
                this.state.secondTeamName,
                this.state.bookMakerAdminData.second_team_lay,
                "#faa9ba",
                "lay",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "manual_bookmaker"
              )}
            >
              <span className="odd layprice">
                {this.state.bookMakerAdminData.second_team_lay}
              </span>
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <span>&nbsp;</span>
          </div>
        </div>
      );

      if (this.state.bookMakerAdminData.enable_draw === "true") {
        var drawSuspended =
          this.state.bookMakerAdminData.draw_suspend === "true"
            ? "bet-info suspended row"
            : "bet-info row";
        returnHtml.push(
          <div className={drawSuspended}>
            <div className="team-name nation  col-6 table-active">
              <span>
                <strong>The Draw</strong>
              </span>
              <p className="box-w4">
                <span
                  className="float-right book"
                  id="book_349"
                  style={{ color: "black" }}
                ></span>{" "}
                <span
                  className="float-right profit"
                  id="profit_349"
                  style={{ color: "black" }}
                ></span>
              </p>

              <p className="box-w4">
                <span
                  className="float-left book"
                  style={{ color: "black" }}
                ></span>{" "}
                <span
                  className="float-left  profit"
                  style={{ color: "black" }}
                ></span>
              </p>
            </div>

            <div
              className="box-w1 back-color col-1"
              style={{ backgroundColor: "#B2D6F0" }}
            >
              {status}

              <span>&nbsp;</span>
            </div>
            <div
              className="box-w1 back-color col-1"
              style={{ backgroundColor: "#92C9F0" }}
            >
              {status}
              <span>&nbsp;</span>
            </div>

            <div className="box-w1 back-color col-1">
              {status}
              <button
                className="bet-sec back "
                onClick={this.handleBidClick.bind(
                  this,
                  "The Draw",
                  this.state.bookMakerAdminData.draw_back,
                  "#92C9F0",
                  "back",
                  this.state.teamTwoSelectionId,
                  this.state.marketId,
                  "draw",
                  this.state.status,
                  "manual_bookmaker"
                )}
              >
                {" "}
                <span className="odd backprice">
                  {this.state.bookMakerAdminData.draw_back}
                </span>
              </button>
            </div>

            <div className="box-w1 lay-color col-1">
              {status}
              <button
                className="bet-sec lay"
                onClick={this.handleBidClick.bind(
                  this,
                  "The Draw",
                  this.state.bookMakerAdminData.draw_lay,
                  "#faa9ba",
                  "lay",
                  this.state.teamTwoSelectionId,
                  this.state.marketId,
                  "draw",
                  this.state.status,
                  "manual_bookmaker"
                )}
              >
                <span className="odd layprice">
                  {this.state.bookMakerAdminData.draw_lay}
                </span>
              </button>
            </div>
            <div
              className="box-w1 lay-color col-1"
              style={{ backgroundColor: "#F8BBC8" }}
            >
              {status}
              <span>&nbsp;</span>
            </div>
            <div
              className="box-w1 lay-color col-1"
              style={{ backgroundColor: "#F6CDD6" }}
            >
              {status}
              <span>&nbsp;</span>
            </div>
          </div>
        );
      }

      return <div>{returnHtml}</div>;
    }
  };

  // showDrawHtml = () => {
  //   if (this.state.draw === true) {
  //     var status = this.state.status;
  //     if (status != 'OPEN') {
  //       var status = this.state.status;
  //     } else {
  //       var status = '';
  //     }
  //     var blockHtml = '';
  //     if (this.state.bookmaker_team3_status === 'SUSPEND') {
  //       var blockHtml = <div className="bet-info suspendedodds row"></div>;
  //     }

  //     return (
  //       <tr className="bet-info ">
  //         <td className="team-name nation table-active">
  //           <span>
  //             <strong>The Draw</strong>
  //           </span>
  //           <p className="box-w4">
  //             <span className="float-left book" id="book_349">
  //               <span
  //                 className={
  //                   this.state.drawTeamTotal > 0
  //                     ? 'text-success'
  //                     : 'text-danger'
  //                 }
  //               >
  //                 {this.state.drawTeamTotal}
  //               </span>
  //             </span>{' '}
  //             <span
  //               className="float-right profit"
  //               id="profit_349"
  //               style={{ color: 'black' }}
  //             >
  //               {this.state.team_profit3} {this.state.stackAmount_team3}
  //             </span>
  //           </p>
  //         </td>

  //         <td
  //           className="box-w1 back-color"
  //           style={{ backgroundColor: '#B2D6F0' }}
  //         >
  //           {blockHtml}
  //           {status}
  //           <button className="bet-sec back ">
  //             {' '}
  //             <span className="odd backprice">{this.state.drawLastBack}</span>
  //             <span className="oddsize">
  //               {this.state.drawLastBackSize}
  //             </span>{' '}
  //           </button>
  //         </td>
  //         <td
  //           className="box-w1 back-color"
  //           style={{ backgroundColor: '#92C9F0' }}
  //         >
  //           <button className="bet-sec back ">
  //             {' '}
  //             <span className="odd backprice">{this.state.drawMiddleBack}</span>
  //             <span className="oddsize">
  //               {this.state.drawMiddleBackSize}
  //             </span>{' '}
  //           </button>
  //         </td>

  //         <td className="box-w1 back-color">
  //           {status}
  //           <button className="bet-sec back">
  //             {' '}
  //             <span className="odd backprice">{this.state.drawFirstBack}</span>
  //             <span className="oddsize">
  //               {this.state.drawFirstBackSize}
  //             </span>{' '}
  //           </button>
  //         </td>

  //         <td className="box-w1 lay-color">
  //           {status}
  //           <button className="bet-sec lay" value={this.state.lastPriceTraded1}>
  //             <span className="odd layprice">{this.state.drawFirstLay}</span>{' '}
  //             <span className="oddsize">{this.state.drawFirstLaySize}</span>
  //           </button>
  //         </td>
  //         <td
  //           className="box-w1 lay-color"
  //           style={{ backgroundColor: '#F8BBC8' }}
  //         >
  //           {status}
  //           <button className="bet-sec lay" value={this.state.lastPriceTraded1}>
  //             <span className="odd layprice">{this.state.drawMiddleLay}</span>
  //             <span className="oddsize">{this.state.drawMiddleLaySize}</span>
  //           </button>
  //         </td>
  //         <td
  //           className="box-w1 lay-color"
  //           style={{ backgroundColor: '#F6CDD6' }}
  //         >
  //           {status}
  //           <button className="bet-sec lay" value={this.state.lastPriceTraded1}>
  //             <span className="odd layprice">{this.state.drawLastLay}</span>
  //             <span className="oddsize">{this.state.drawLastLaySize}</span>
  //           </button>
  //         </td>
  //       </tr>
  //     );
  //   }
  // };
  showDrawHtml = () => {
    if (this.state.draw === true) {
      var status = this.state.status;
      if (status != "OPEN") {
        var status = this.state.status;
      } else {
        var status = "";
      }
      var blockHtml = "";
      if (this.state.oddsMatchSuspend) {
        var blockHtml = (
          <div className="bet-info suspendedodds row">
            <span>SUSPENDED</span>
          </div>
        );
      }
      var team_profit3 =
        this.state.team_profit3 === undefined || this.state.team_profit3 === ""
          ? this.state.team_profit3
          : parseFloat(this.state.team_profit3);

      return (
        <tr className="bet-info ">
          <td className="team-name nation">
            <span>
              <strong>The Draw</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-left book"
                id="book_349"
                style={{ color: "black" }}
              >
                {this.state.profit14}
              </span>{" "}
              <span
                className="float-right profit"
                id="profit_349"
                style={{ color: "black" }}
              >
                {team_profit3} {this.state.stackAmount_team3}
              </span>
            </p>
          </td>

          <td
            className="box-w1 back-color"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {blockHtml}
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawLastBack,
                "#B2D6F0",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
            >
              {" "}
              <span className="odd backprice">{this.state.drawLastBack}</span>
              {this.state.drawLastBackSize}
              {this.state.drawLastBackSize > 0 ? " K" : ""}{" "}
            </button>
          </td>
          <td
            className="box-w1 back-color"
            style={{ backgroundColor: "#92C9F0" }}
          >
            <button
              className="bet-sec back "
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawMiddleBack,
                "#92C9F0",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.drawMiddleBack}
              </span>{" "}
              {this.state.drawMiddleBackSize}
              {this.state.drawMiddleBackSize > 0 ? " K" : ""}{" "}
            </button>
          </td>

          <td className="box-w1 back-color">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawFirstBack,
                "#72bbef",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.drawFirstBack}
              </span>{" "}
              {this.state.drawFirstBackSize}
              {this.state.drawFirstBackSize > 0 ? " K" : ""}{" "}
            </button>
          </td>

          <td className="box-w1 lay-color">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawFirstLay,
                "#faa9ba",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
              value={this.state.lastPriceTraded1}
            >
              <span className="odd layprice">{this.state.drawFirstLay}</span>
              {this.state.drawFirstLaySize}
              {this.state.drawFirstLaySize > 0 ? " K" : ""}
            </button>
          </td>
          <td
            className="box-w1 lay-color"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <button
              className="bet-sec lay"
              value={this.state.lastPriceTraded1}
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawMiddleLay,
                "#F8BBC8",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
            >
              <span className="odd layprice">{this.state.drawMiddleLay}</span>
              {this.state.drawMiddleLaySize}
              {this.state.drawMiddleLaySize > 0 ? " K" : ""}
            </button>
          </td>
          <td
            className="box-w1 lay-color"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <button
              className="bet-sec lay"
              value={this.state.lastPriceTraded1}
              onClick={this.handleBidClick.bind(
                this,
                this.state.drawTeamName,
                this.state.drawLastLay,
                "#F6CDD6",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "odds"
              )}
            >
              <span className="odd layprice">{this.state.drawLastLay}</span>
              {this.state.drawLastLaySize}
              {this.state.drawLastLaySize > 0 ? " K" : ""}
            </button>
          </td>
        </tr>
      );
    }
  };

  showBookMarketAllHtml = () => {
    var returnHtml = [];
    if (this.state.showBookMakerLiveApiData === false) {
      return <div>{returnHtml}</div>;
    }
    console.log("state", this.state);
    if (
      this.state.bookmakerFirstTeamFound === true ||
      this.state.bookmakerSecondTeamFound === true ||
      this.state.bookmaker_draw === true
    ) {
      returnHtml.push(
        <div className="row">
          <div className="col-6">
            Total Match: {this.state.twoteamtotalmatch}
          </div>
          <div className="col-1 box-w1">&nbsp;</div>
          <div className=" col-1 box-w1">&nbsp;</div>
          <div className="col-1 back box-w1">Back</div>
          <div className="col-1 lay box-w1">Lay</div>
          <div className="col-1 box-w1">&nbsp;</div>
          <div className="col-1 box-w1">&nbsp;</div>
        </div>
      );
    }
    if (this.state.bookmakerFirstTeamFound === true) {
      //console.log(this.state.bookmaker_a_lay_1);
      var suspended =
        this.state.bookmaker_a_back_1 == 0 || this.state.isSuspend === 1
          ? "bet-info suspended row"
          : "bet-info row";
      var team_profit4 =
        this.state.team_profit4 === undefined || this.state.team_profit4 === ""
          ? this.state.team_profit4
          : parseFloat(this.state.team_profit4);
      returnHtml.push(
        <div className={suspended}>
          <div className="team-name nation col-6" id="10301">
            <span>
              <strong>{this.state.firstTeamName}</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-right book"
                id="book_10301"
                style={{ color: "black" }}
              >
                {" "}
              </span>{" "}
              <span
                className="float-right profit"
                id="profit_10301"
                style={{ color: "black" }}
              >
                {team_profit4}
                {this.state.stackAmount_team4}
              </span>
            </p>
            <p className="box-w4">
              <span className="float-left book" style={{ color: "black" }}>
                {" "}
                {parseFloat(this.state.profit15)}
              </span>{" "}
              <span
                className="float-left  profit"
                style={{ color: "black" }}
              ></span>
            </p>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_back_3,
                "#B2D6F0",
                "back",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_a_back_3}
              </span>
              {this.state.bookmaker_a_back_6}
              {this.state.bookmaker_a_back_6 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#92C9F0" }}
          >
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_back_2,
                "#92C9F0",
                "back",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_a_back_2}
              </span>
              {this.state.bookmaker_a_back_5}{" "}
              {this.state.bookmaker_a_back_5 > 0 ? " K" : ""}{" "}
            </button>
          </div>

          <div className="box-w1 back-color col-1">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_back_1,
                "#72bbef",
                "back",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_a_back_1}
              </span>
              {this.state.bookmaker_a_back_4}
              {this.state.bookmaker_a_back_4 > 0 ? " K" : ""}{" "}
            </button>
          </div>

          <div className="box-w1 lay-color col-1">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_lay_1,
                "#FAA9BA",
                "lay",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_a_lay_1}
              </span>
              {this.state.bookmaker_a_lay_4}
              {this.state.bookmaker_a_lay_4 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_lay_2,
                "#F8BBC8",
                "lay",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_a_lay_2}
              </span>
              {this.state.bookmaker_a_lay_5}
              {this.state.bookmaker_a_lay_5 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.firstTeamName,
                this.state.bookmaker_a_lay_3,
                "#F6CDD6",
                "lay",
                this.state.teamOneSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_a_lay_3}
              </span>
              {this.state.bookmaker_a_lay_6}
              {this.state.bookmaker_a_lay_6 > 0 ? " K" : ""}
            </button>
          </div>
        </div>
      );
    }

    if (this.state.bookmakerSecondTeamFound === true) {
      var suspended1 =
        this.state.bookmaker_b_back_1 == 0 || this.state.isSuspend === 1
          ? "bet-info suspended row"
          : "bet-info row";
      var team_profit5 =
        this.state.team_profit5 === undefined || this.state.team_profit5 === ""
          ? this.state.team_profit5
          : parseFloat(this.state.team_profit5);
      returnHtml.push(
        <div className={suspended1}>
          <div className="team-name nation  col-6">
            <span>
              <strong>{this.state.secondTeamName}</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-right book"
                id="book_349"
                style={{ color: "black" }}
              >
                {team_profit5}
                {this.state.stackAmount_team5}
              </span>{" "}
              <span
                className="float-left profit"
                id="profit_349"
                style={{ color: "black" }}
              >
                {parseFloat(this.state.profit16)}
              </span>
            </p>

            <p className="box-w4">
              <span
                className="float-left book"
                style={{ color: "black" }}
              ></span>{" "}
              <span
                className="float-left  profit"
                style={{ color: "black" }}
              ></span>
            </p>
          </div>

          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {status}

            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_back_3,
                "#B2D6F0",
                "back",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamone",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_b_back_3}{" "}
              </span>
              {this.state.bookmaker_b_back_6}
              {this.state.bookmaker_b_back_6 > 0 ? " K" : ""}{" "}
            </button>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#92C9F0" }}
          >
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_back_2,
                "#92C9F0",
                "back",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_b_back_2}
              </span>{" "}
              {this.state.bookmaker_b_back_5}
              {this.state.bookmaker_b_back_5 > 0 ? " K" : ""}{" "}
            </button>
          </div>

          <div className="box-w1 back-color col-1">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_back_1,
                "#92C9F0",
                "back",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_b_back_1}
              </span>{" "}
              {this.state.bookmaker_b_back_4}{" "}
              {this.state.bookmaker_b_back_4 > 0 ? " K" : ""}
            </button>
          </div>

          <div className="box-w1 lay-color col-1">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_lay_1,
                "#faa9ba",
                "lay",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_b_lay_1}
              </span>
              {this.state.bookmaker_b_lay_4}
              {this.state.bookmaker_b_lay_4 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_lay_2,
                "#F8BBC8",
                "lay",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_b_lay_2}
              </span>
              {this.state.bookmaker_b_lay_5}
              {this.state.bookmaker_b_lay_5 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.secondTeamName,
                this.state.bookmaker_b_lay_3,
                "#F6CDD6",
                "lay",
                this.state.teamTwoSelectionId,
                this.state.marketId,
                "teamtwo",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_b_lay_3}
              </span>
              {this.state.bookmaker_b_lay_6}
              {this.state.bookmaker_b_lay_6 > 0 ? " K" : ""}
            </button>
          </div>
        </div>
      );
    }

    if (this.state.bookmaker_draw === true) {
      var suspended2 =
        this.state.bookmaker_d_back_1 == 0 || this.state.isSuspend === 1
          ? "bet-info suspended row"
          : "bet-info row";
      var team_profit6 =
        this.state.team_profit6 === undefined || this.state.team_profit6 === ""
          ? this.state.team_profit6
          : parseFloat(this.state.team_profit6);
      returnHtml.push(
        <div className={suspended2}>
          <div className="team-name nation col-6">
            <span>
              <strong>Draw</strong>
            </span>
            <p className="box-w4">
              <span
                className="float-left book"
                id="book_349"
                style={{ color: "black" }}
              >
                {this.state.profit17}
              </span>{" "}
              <span
                className="float-right profit"
                id="profit_349"
                style={{ color: "black" }}
              >
                {team_profit6}
                {this.state.stackAmount_team6}
              </span>
            </p>
          </div>

          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#B2D6F0" }}
          >
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_back_3,
                "#B2D6F0",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_d_back_3}
              </span>
              {this.state.bookmaker_d_back_6}{" "}
              {this.state.bookmaker_d_back_6 > 0 ? " K" : ""}{" "}
            </button>
          </div>
          <div
            className="box-w1 back-color col-1"
            style={{ backgroundColor: "#92C9F0" }}
          >
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_back_2,
                "#92C9F0",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_d_back_2}
              </span>{" "}
              {this.state.bookmaker_d_back_5}
              {this.state.bookmaker_d_back_5 > 0 ? " K" : ""}{" "}
            </button>
          </div>

          <div className="box-w1 back-color col-1">
            {status}
            <button
              className="bet-sec back "
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_back_1,
                "#72bbef",
                "back",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
            >
              {" "}
              <span className="odd backprice">
                {this.state.bookmaker_d_back_1}
              </span>{" "}
              {this.state.bookmaker_d_back_4}{" "}
              {this.state.bookmaker_d_back_4 > 0 ? " K" : ""}
            </button>
          </div>

          <div className="box-w1 lay-color col-1">
            {status}
            <button
              className="bet-sec lay"
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_lay_1,
                "#faa9ba",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betmatch"
              )}
              value={this.state.bookmaker_d_lay_4}
            >
              <span className="odd layprice">
                {this.state.bookmaker_d_lay_1}
              </span>
              {this.state.bookmaker_d_lay_4}
              {this.state.bookmaker_d_lay_4 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F8BBC8" }}
          >
            {status}
            <button
              className="bet-sec lay"
              value={this.state.bookmaker_d_lay_5}
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_lay_2,
                "#F8BBC8",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_d_lay_2}
              </span>
              {this.state.bookmaker_d_lay_5}
              {this.state.bookmaker_d_lay_5 > 0 ? " K" : ""}
            </button>
          </div>
          <div
            className="box-w1 lay-color col-1"
            style={{ backgroundColor: "#F6CDD6" }}
          >
            {status}
            <button
              className="bet-sec lay"
              value={this.state.bookmaker_d_lay_6}
              onClick={this.handleBidClickBook.bind(
                this,
                this.state.drawTeamName,
                this.state.bookmaker_d_lay_3,
                "#F6CDD6",
                "lay",
                this.state.drawSelectionId,
                this.state.marketId,
                "draw",
                this.state.status,
                "bookmaker",
                "betunmatch"
              )}
            >
              <span className="odd layprice">
                {this.state.bookmaker_d_lay_3}
              </span>
              {this.state.bookmaker_d_lay_6}
              {this.state.bookmaker_d_lay_6 > 0 ? " K" : ""}
            </button>
          </div>
        </div>
      );
    }

    return <div>{returnHtml}</div>;
  };

  showTableHtml = () => {
    if (this.state.betDataFound === true) {
      const html = [];
      const html111 = [];
      var profit12 = 0;
      var profit13 = 0;
      var loss = 0;
      //var custom_this=this;
      var teamOneSelectionId = this.state.teamOneSelectionId;
      var teamTwoSelectionId = this.state.teamOneSelectionId;

      for (let i = 0; i < this.state.getResults.length; i++) {
        for (var b = 0; b < this.state.getResults[i].length; b++) {
          console;
          const value = this.state.getResults[i][b];

          var inPlayClass = value.inPlay === true ? "active" : "";
          var colorClass = value.color != undefined ? value.color : "";
          var fullname =
            value.user_id != undefined ? value.user_id.username : "";
          var setNewStatus = value.status === "pending" ? "deleted" : "pending";
          var setActionIcon =
            value.status === "pending" ? "fa-trash" : "fa-undo";
          var setActionIconColor = value.status === "pending" ? "red" : "green";
          var ActionBtn = "";
          if (value.status !== "completed") {
            ActionBtn =
              this.state.userData.userType === 1 ? (
                <i
                  onClick={this.betDeleteClickConfirm.bind(
                    this,
                    value._id,
                    setNewStatus
                  )}
                  style={{ color: setActionIconColor }}
                  className={"fa " + setActionIcon}
                ></i>
              ) : (
                ""
              );
          }
          if (value.type === "match") {
            html.push(
              <tr style={{ background: colorClass }}>
                <td style={{ textAlign: "center" }}> {fullname} </td>
                <td style={{ textAlign: "center" }}> {value.team_name} </td>
                <td style={{ textAlign: "center" }}> {value.odds} </td>
                <td style={{ textAlign: "center" }}> {value.stake} </td>
                <td style={{ textAlign: "center" }}> {ActionBtn} </td>
              </tr>
            );
          } else {
            html111.push(
              <tr style={{ background: colorClass }}>
                <td style={{ textAlign: "center" }}> {fullname} </td>
                <td style={{ textAlign: "center" }}> {value.team_name} </td>
                <td style={{ textAlign: "center" }}> {value.odds} </td>
                <td style={{ textAlign: "center" }}> {value.stake} </td>
                <td style={{ textAlign: "center" }}> {ActionBtn} </td>
              </tr>
            );
          }
        }
      }

      return (
        <div>
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#home">
                Match
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#menu1">
                Un Match
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div id="home" className="container tab-pane active">
              <br />
              <table className="table coupon-table scorall">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}> User Name</th>
                    <th style={{ textAlign: "center" }}> Team Name</th>
                    <th style={{ textAlign: "center" }}> Odds</th>
                    <th style={{ textAlign: "center" }}> Stake</th>
                    <th style={{ textAlign: "center" }}> Action </th>
                  </tr>
                </thead>
                <tbody className="scorall">{html}</tbody>
              </table>
            </div>
            <div id="menu1" className="container tab-pane">
              <table className="table coupon-table scorall">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}> User Name</th>
                    <th style={{ textAlign: "center" }}> Team Name</th>
                    <th style={{ textAlign: "center" }}> Odds</th>
                    <th style={{ textAlign: "center" }}> Stake</th>
                    <th style={{ textAlign: "center" }}> Action </th>
                  </tr>
                </thead>
                <tbody className="scorall">{html111}</tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }
  };
  onFancybetClick = (e) => {
    let currVal = e.target.value;
    const { getFancybet } = this.state;
    this.setState(() => ({
      getFancybet: !getFancybet,
      amountFancybetBal: currVal,
    }));
  };
  onFancybetSecondClick = (f) => {
    let currSecVal = f.target.value;
    const { getFancySecondbet } = this.state;
    this.setState(() => ({
      getFancySecondbet: !getFancySecondbet,
      amountFancybetBalSecond: currSecVal,
    }));
    $(".pancypick").click(function () {});
  };
  showFancyTableHtml = () => {
    if (this.state.fancybet_betDataFound === true) {
      const html = [];

      for (var a = 0; a < this.state.fancybet_getResults.length; a++) {
        const value = this.state.fancybet_getResults[a];
        html.push(
          <tr className="bet-info">
            <td className="team-name nation">
              {" "}
              <span>
                <strong style={{ color: "font-weight:normal" }}>
                  {value.title}
                </strong>
              </span>
              <p>
                <span
                  className="float-left book"
                  id="book_175"
                  style={{ color: "black" }}
                >
                  0
                </span>{" "}
                <span className="float-right profit" id="profit_175"></span>
              </p>
            </td>
            <td className="lay-color box-w1">
              <button
                className="bet-sec lay ses_row pancypick"
                value={value.no_first}
                onClick={this.onFancybetClick.bind(this)}
              >
                <span className="odd Jaya" id={"nofirstpink" + a}>
                  {value.no_first}
                </span>
                {value.no_second}
              </button>
            </td>
            <td className="text-center back box-w1">
              <button
                className="bet-sec lay ses_row"
                value={value.yes_first}
                onClick={this.onFancybetSecondClick.bind(this)}
              >
                <span className="odd">{value.yes_first}</span>
                {value.yes_second}
              </button>
            </td>
            <td className="text-right p-r-10 box-w2">
              <span>Min/Max</span>
              <br></br> {value.minimum}/{value.maximum}
            </td>
          </tr>
        );
      }
      return (
        <table className="coupon-table table table-bordered">
          <thead>
            <tr>
              <th></th>
              <th className="text-center  box-w1 lay">No</th>
              <th className="text-center  box-w1 lay">Yes</th>
              <th className="box-w2"></th>
            </tr>
          </thead>

          <tbody>{html}</tbody>
        </table>
      );
    }
  };
  handleChange = (event) => {
    let { name, value } = event.target;
    if (value <= 0) {
      return false;
    }

    var profit = this.state.profit;
    // ////////////console.logprofit);
    var stackAmount = this.state.stake_amount;

    if (this.state.betClick == true) {
      if (this.state.type === "back") {
        profit = parseFloat(this.state.oddVal) - 1;
        profit = profit.toFixed(2) * event.target.value;

        // ////////////console.logthis.state.betMatchType);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit1: profit });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit2: profit });
        }
        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit3: profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team2: "-" + event.target.value });
          this.setState({ stackAmount_team3: "-" + event.target.value });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team1: "-" + event.target.value });
          this.setState({ stackAmount_team3: "-" + event.target.value });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team1: "-" + event.target.value });
          this.setState({ stackAmount_team2: "-" + event.target.value });
        }

        this.setState({
          [name]: value,
          profit: profit,
          emptyField: false,
          errMsg: "",
        });
      } else if (this.state.type === "lay") {
        profit = parseFloat(this.state.oddVal) - 1;
        profit = profit.toFixed(2) * event.target.value;
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit1: "-" + profit });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit2: "-" + profit });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit3: "-" + profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team2: event.target.value });
          this.setState({ stackAmount_team3: event.target.value });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team1: event.target.value });
          this.setState({ stackAmount_team3: event.target.value });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team1: event.target.value });
          this.setState({ stackAmount_team2: event.target.value });
        }
        this.setState({
          [name]: value,
          profit: event.target.value,
          emptyField: false,
          errMsg: "",
        });
      }
    }
    if (this.state.betClick2 == true) {
      if (this.state.type === "back") {
        if (Number.isInteger(parseFloat(this.state.oddVal)) == true) {
          profit = parseFloat(this.state.oddVal) / parseFloat(100);
        } else {
          profit = parseFloat(this.state.oddVal) - parseFloat(1);
        }

        profit = profit.toFixed(2) * parseFloat(event.target.value);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit4: profit });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit5: profit });
        }
        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit6: profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team5: "-" + event.target.value });
          this.setState({ stackAmount_team6: "-" + event.target.value });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team4: "-" + event.target.value });
          this.setState({ stackAmount_team6: "-" + event.target.value });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team4: "-" + event.target.value });
          this.setState({ stackAmount_team5: "-" + event.target.value });
        }

        this.setState({
          [name]: value,
          profit: profit,
          emptyField: false,
          errMsg: "",
        });
      } else if (this.state.type === "lay") {
        profit = parseFloat(this.state.oddVal) - parseFloat(1);
        profit = profit.toFixed(2) * parseFloat(event.target.value);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit4: "-" + profit });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit5: "-" + profit });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit6: "-" + profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team5: event.target.value });
          this.setState({ stackAmount_team6: event.target.value });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team4: event.target.value });
          this.setState({ stackAmount_team6: event.target.value });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team4: event.target.value });
          this.setState({ stackAmount_team5: event.target.value });
        }
        this.setState({
          [name]: value,
          profit: event.target.value,
          emptyField: false,
          errMsg: "",
        });
      }
    }
  };
  handleChangeStakeamount = (event) => {
    this.setState({ stake_amount: event.target.value });
  };
  handleChange_session_input = (event) => {
    var profit = this.state.profit;

    this.setState({ session_input: event.target.value });
  };

  handleButtonsClick = (getAmount) => {
    if (this.state.betClick == true) {
      var profit = "";
      if (this.state.type === "back") {
        profit = parseFloat(this.state.oddVal) - 1;
        profit = profit.toFixed(2) * getAmount;

        // ////////////console.logthis.state.betMatchType);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit1: profit });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit2: profit });
        }
        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit3: profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team2: "-" + getAmount });
          this.setState({ stackAmount_team3: "-" + getAmount });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team1: "-" + getAmount });
          this.setState({ stackAmount_team3: "-" + getAmount });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team1: "-" + getAmount });
          this.setState({ stackAmount_team2: "-" + getAmount });
        }
      } else if (this.state.type === "lay") {
        //profit = parseFloat(this.state.oddVal)-1;
        //profit = getAmount.toFixed(2) * getAmount;
        profit = getAmount.toFixed(0);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit1: "-" + profit });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit2: "-" + profit });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit3: "-" + profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team2: getAmount });
          this.setState({ stackAmount_team3: getAmount });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team1: getAmount });
          this.setState({ stackAmount_team3: getAmount });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team1: getAmount });
          this.setState({ stackAmount_team2: getAmount });
        }
      }

      this.setState({ stake_amount: getAmount, profit: profit });
    }
    if (this.state.betClick2 == true) {
      var profit = "";
      if (this.state.type === "back") {
        if (Number.isInteger(parseFloat(this.state.oddVal)) == true) {
          profit = parseFloat(this.state.oddVal) / parseFloat(100);
        } else {
          profit = parseFloat(this.state.oddVal) - parseFloat(1);
        }

        profit = profit.toFixed(2) * getAmount;

        // ////////////console.logthis.state.betMatchType);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit4: profit });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit5: profit });
        }
        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit6: profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team5: "-" + getAmount });
          this.setState({ stackAmount_team6: "-" + getAmount });
        }
        if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team4: "-" + getAmount });
          this.setState({ stackAmount_team6: "-" + getAmount });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team4: "-" + getAmount });
          this.setState({ stackAmount_team5: "-" + getAmount });
        }
      } else if (this.state.type === "lay") {
        //profit = parseFloat(this.state.oddVal)-1;
        //profit = getAmount.toFixed(2) * getAmount;
        profit = getAmount.toFixed(0);
        if (this.state.betMatchType == "teamone") {
          this.setState({ team_profit4: "-" + profit });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ team_profit5: "-" + profit });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ team_profit6: "-" + profit });
        }

        if (this.state.betMatchType == "teamone") {
          this.setState({ stackAmount_team5: getAmount });
          this.setState({ stackAmount_team6: getAmount });
        } else if (this.state.betMatchType == "teamtwo") {
          this.setState({ stackAmount_team4: getAmount });
          this.setState({ stackAmount_team6: getAmount });
        }

        if (this.state.betMatchType == "draw") {
          this.setState({ stackAmount_team4: getAmount });
          this.setState({ stackAmount_team5: getAmount });
        }
      }

      this.setState({ stake_amount: getAmount, profit: profit });
    }
  };
  handleButtonsNewClick = (getAmount) => {
    this.setState({ stake_amount: getAmount });
  };

  handleBidClick = (
    teamName,
    oddVal,
    color,
    type,
    selectionId,
    marketId,
    getMatchType,
    status,
    betOn
  ) => {
    this.setState({ betClick: true, betClick1: false, betClick2: false });
    this.setState({
      teamName: teamName,
      oddVal: oddVal,
      color: color,
      type: type,
      betSelectionId: selectionId,
      betMarketId: marketId,
      betMatchType: getMatchType,
      betOn: "odds",
      stake_amount: "",
      profit22: "",
      profit: "",
      team_profit1: "",
      team_profit2: "",
      stackAmount_team3: "",
      stackAmount_team1: "",
      stackAmount_team2: "",
      team_profit3: "",
    });
  };

  handleBidClickBook = (
    teamName,
    oddVal,
    color,
    type,
    selectionId,
    marketId,
    getMatchType,
    status,
    betOn
  ) => {
    this.setState({ betClick: false, betClick1: false, betClick2: true });
    this.setState({
      teamName: teamName,
      oddVal: oddVal,
      color: color,
      type: type,
      betSelectionId: selectionId,
      betMarketId: marketId,
      betMatchType: getMatchType,
      betOn: betOn,
      stake_amount: "",
      profit22: "",
      profit: "",
      team_profit1: "",
      team_profit2: "",
      stackAmount_team3: "",
      stackAmount_team1: "",
      stackAmount_team2: "",
      team_profit3: "",

      team_profit4: "",
      team_profit5: "",
      stackAmount_team4: "",
      stackAmount_team5: "",
      stackAmount_team6: "",
      team_profit6: "",
    });
  };

  handleBidClickSession = (
    color,
    headname,
    no,
    marketId,
    SessInptNo,
    yes,
    index1,
    yes_no_STAKE
  ) => {
    if (SessInptNo != 0) {
      this.setState({ betClick1: true, betClick: false, betClick2: false });
    }

    $("#btn_val").focus();
    this.setState({
      color: color,
      headname: headname,
      session_input: SessInptNo,
      yes_no_STAKE: yes_no_STAKE,
      yes: yes,
      no: no,
      stake_amount: "",
      profit22: "",
      profit: "",
      team_profit1: "",
      team_profit2: "",
      stackAmount_team1: "",
      stackAmount_team2: "",
      key_index: index1,
    });
  };
  handleBidCrossClick = () => {
    this.setState({
      betClick: false,
      betClick1: false,
      teamName: "",
      oddVal: "",
      color: "",
      type: "",
      betSelectionId: "",
      betMarketId: "",
      betMatchType: "",
      stake_amount: "",
      profit: "",
    });
  };
  handleDepoWithdrPopupClose = () => {
    this.setState({ showUserAmountPopup: false });
  };
  showVideo = () => {
    if (this.state.showVideo === true) {
      return (
        <iframe
          src={
            "https://new.apple365.bet/tvsetting/getMatchTvFeedApi/" +
            this.state.currentMatchId +
            "/18.159.217.229"
          }
        ></iframe>
      );
    } else {
      return <div>&nbsp;</div>;
    }
  };

  handleLiveTvClick = () => {
    this.setState({ showVideo: !this.state.showVideo });
  };

  handleBetLockClick = (status, type) => {
    if (status == 1 || status == 2) {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlock-history/" +
            this.props.match.params.id +
            "/" +
            status +
            "/" +
            "odds",
          { headers }
        )
        .then((resp) => {
          var resp = resp.data;
          this.setState({ maxminBet: resp });
        });
      if (status == 1) {
        alert("Bet Lock Successfully");
      }
      if (status == 2) {
        alert("Bet UnLock Successfully");
      }
    } else {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlock-history/" +
            this.props.match.params.id +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var html = [];
          //console.log(resp.data.data);

          this.setState({ bethistory: resp.data.data });
        });
      this.setState({ betlockHistory: true });
    }
  };
  handleBetLockClick1 = (status, type) => {
    if (status == 1 || status == 2) {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlockuser/" +
            this.props.match.params.id +
            "/" +
            status +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var resp = resp.data;
          this.setState({ maxminBet: resp });
        });
      if (status == 1) {
        alert("Bet Lock Successfully");
      }
      if (status == 2) {
        alert("Bet UnLock Successfully");
      }
    } else {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlock-history/" +
            this.props.match.params.id +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var html = [];
          this.setState({ bethistory: resp.data.data });
        });
      this.setState({ betlockHistory: true });
    }
  };
  showTableHtmlBetLock = () => {
    if (this.state.bethistory != undefined) {
      var html1 = [];
      for (var a = 0; a < this.state.bethistory.length; a++) {
        for (var b = 0; b < this.state.bethistory[a].length; b++) {
          const value = this.state.bethistory[a][b];
          //console.log(value);
          var check = "";
          if (value.status == 1) {
            check = "Bet Lock";
          }
          if (value.status == 2) {
            check = "Bet UnLock";
          }
          var mainHtml = (
            <tr role="row" className="odd">
              <td>{value.user_id.username} &nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>
                {" "}
                <span id={"check_11_" + a}>{check}</span>
                <div id={"show_message_" + a}></div>
              </td>
              <td>{value.type}</td>
              <td>
                <input
                  type="checkbox"
                  onClick={this.handleBidClickChekbox.bind(this, value._id, a)}
                ></input>
              </td>
            </tr>
          );
          html1.push(mainHtml);
        }
      }
      return <tbody>{html1}</tbody>;
    }
  };
  handleBetLockClick = (status, type) => {
    if (status == 1 || status == 2) {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlockuser/" +
            this.props.match.params.id +
            "/" +
            status +
            "/" +
            "odds",
          { headers }
        )
        .then((resp) => {
          var resp = resp.data;
          this.setState({ maxminBet: resp });
        });
      if (status == 1) {
        alert("Bet Lock Successfully");
      }
      if (status == 2) {
        alert("Bet UnLock Successfully");
      }
    } else {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlock-history/" +
            this.props.match.params.id +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var html = [];
          //console.log(resp.data.data);

          this.setState({ bethistory: resp.data.data });
        });
      this.setState({ betlockHistory: true });
    }
  };
  handleUserLockClick = () => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };

    let matchid = this.props.match.params.id;
    // this.callMatchOddsApi()
    axios
      .get(baseUrl + "/userbetlist_admin/" + matchid, { headers })
      .then((resp) => {
        var resps = resp.data;
        var profit12 = 0;
        var profit13 = 0;
        if (resps.success === true) {
          this.setState({ getResults1: resps.data, betDataFound1: true });
        }
      });

    this.setState({ userLogHistory: true });
  };

  handleUserBookClick = () => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };

    let matchid = this.props.match.params.id;
    // this.callMatchOddsApi()
    axios
      .get(baseUrl + "/userbetlistbook_admin/" + matchid, { headers })
      .then((resp) => {
        var resps = resp.data;
        var profit12 = 0;
        var profit13 = 0;
        if (resps.success === true) {
          this.setState({ getResults1: resps.data, betDataFound1: true });
        }
      });

    this.setState({ userLogHistory: true });
  };

  betlockHistoryHide = () => {
    //this.setState({respStatus:true,respMessage:"Status Updated Successfully."});
    this.setState({ userLogHistory: false });
  };

  handleBetLockClick1 = (status, type) => {
    if (status == 1 || status == 2) {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlockuser/" +
            this.props.match.params.id +
            "/" +
            status +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var resp = resp.data;
          this.setState({ maxminBet: resp });
        });
      if (status == 1) {
        alert("Bet Lock Successfully");
      }
      if (status == 2) {
        alert("Bet UnLock Successfully");
      }
    } else {
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      axios
        .get(
          baseUrl +
            "/api/betlock-history/" +
            this.props.match.params.id +
            "/" +
            type,
          { headers }
        )
        .then((resp) => {
          var html = [];
          //console.log(resp.data.data);

          this.setState({ bethistory: resp.data.data });
        });
      this.setState({ betlockHistory: true });
    }

    //this.setState({respStatus:true,respMessage:"Status Updated Successfully."});
  };
  handleBidClickChekbox = (id, a) => {
    let headers = {
      Authorization: "Bearer " + this.state.accessToken,
    };
    axios.get(baseUrl + "/betlock-update/" + id, { headers }).then((resp) => {
      alert(resp.data.message);
      $("#check_11_" + a).remove();
      $("#show_message_" + a).html(resp.data.message);
    });
  };
  showTableHtmlBetLock = () => {
    if (this.state.bethistory != undefined) {
      var html1 = [];

      //return <center>No bet markets!</center>

      for (var a = 0; a < this.state.bethistory.length; a++) {
        for (var b = 0; b < this.state.bethistory[a].length; b++) {
          const value = this.state.bethistory[a][b];
          //console.log(value);
          var check = "";
          if (value.status == 1) {
            check = "Bet Lock";
          }
          if (value.status == 2) {
            check = "Bet UnLock";
          }
          var mainHtml = (
            <tr role="row" className="odd">
              <td>{value.user_id.username} &nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td>
                {" "}
                <span id={"check_11_" + a}>{check}</span>
                <div id={"show_message_" + a}></div>
              </td>
              <td>{value.type}</td>
              <td>
                <input
                  type="checkbox"
                  onClick={this.handleBidClickChekbox.bind(this, value._id, a)}
                ></input>
              </td>
            </tr>
          );
          html1.push(mainHtml);
        }
      }

      // if(value.eventName!==matchName){

      return <tbody>{html1}</tbody>;
    }
  };
  showTableUserLock = () => {
    if (this.state.betDataFound1 === true) {
      //console.log(this.state.userdataFoundNew);
      const html = [];
      var profit12 = 0;
      var profit13 = 0;
      var loss = 0;
      //var custom_this=this;
      var teamOneSelectionId = this.state.teamOneSelectionId;
      var teamTwoSelectionId = this.state.teamOneSelectionId;
      let headers = {
        Authorization: "Bearer " + this.state.accessToken,
      };
      var result = [];
      var arr_data = [];
      var c = 0;

      for (let i = 0; i < this.state.getResults1.length; i++) {
        var value = this.state.getResults1[i];
        html.push(
          <tr>
            <td style={{ textAlign: "center" }}> {value.username}</td>

            <td style={{ textAlign: "center" }}> {value.firstTeamTotal} </td>
            <td style={{ textAlign: "center" }}>{value.secondTeamTotal} </td>
            <td style={{ textAlign: "center" }}>{value.drawTeamTotal} </td>
          </tr>
        );
      }
      return html;
    }

    //// // //////////console.log(this.state.profit12);
  };

  betlockHistoryHide2 = () => {
    this.setState({ betlockHistory: false });
  };

  userLogHistoryHide = () => {
    this.setState({ userLogHistory: false });
  };

  render() {
    var blockOddsHtml = "";
    if (this.state.oddsMatchSuspend) {
      var blockOddsHtml = (
        <div className="bet-info suspendedodds row">
          <span>SUSPENDED</span>
        </div>
      );
    }
    var change_password = localStorage.getItem("change_password");
    if (change_password != "" && change_password != null) {
      return <Redirect to="/change_password" />;
    }
    var suspended = "bet-info ";
    if (this.state.bookmaker_a_status === "SUSPENDED") {
      suspended = "bet-info suspended row";
    }
    var suspended1 = "bet-info ";
    if (this.state.bookmaker_b_status === "SUSPENDED") {
      suspended1 = "bet-info suspended row";
    }
    var suspended2 = "bet-info row";

    if (this.state.bookmaker_d_status === "SUSPENDED") {
      suspended2 = "bet-info suspended row";
    }

    var new_array = [];
    var new_array1 = "";
    var datafancy = this.state.data123;
    if (this.state.sessiondata != undefined) {
      for (var i = 0; i < this.state.sessiondata.length; i++) {
        var fancy_suspend = "box-w1 lay-color fb_td";
        var fancy_suspend1 = "box-w1 back-color fb_td";
        var data123 = datafancy;

        if (data123 != undefined) {
          var newteamname = this.state.sessiondata[i].RunnerName;
          var toatlprice = "";
          var found = data123.findIndex(function (element) {
            return element.teamname === newteamname;
          });

          if (found >= 0) {
            if (this.state.sessiondata[i].LayPrice1 == 0) {
              fancy_suspend = "box-w1 lay-color fb_td suspended ";
            }
            if (this.state.sessiondata[i].BackPrice1 == 0) {
              fancy_suspend1 = "box-w1 back-color fb_td suspended";
            }
            new_array1 = (
              <tr>
                <td className="fb_64">
                  <a href="#">
                    {" "}
                    {this.state.sessiondata[i].RunnerName}
                    &nbsp;{" "}
                  </a>

                  <span classNamen="text-danger"> -{data123[found].stake}</span>
                </td>
                <td className={fancy_suspend}>
                  <button
                    value={i}
                    onClick={this.handleBidClickSession.bind(
                      this,
                      "#faa9ba",
                      this.state.sessiondata[i].RunnerName,
                      "no",
                      this.state.sessiondata[i].marketId,
                      this.state.sessiondata[i].LayPrice1,
                      "",
                      this.state.sessiondata[i].market_id
                    )}
                    className="bet-sec lay"
                  >
                    <span className="odd layprice">
                      {" "}
                      {this.state.sessiondata[i].LayPrice1}
                    </span>
                    {this.state.sessiondata[i].LaySize1}
                  </button>
                </td>

                <td className="box-w1 back-color fb_td">
                  <button
                    className="bet-sec back"
                    value={i}
                    onClick={this.handleBidClickSession.bind(
                      this,
                      "#72bbef",
                      this.state.sessiondata[i].RunnerName,
                      "no",
                      this.state.sessiondata[i].marketId,
                      this.state.sessiondata[i].BackPrice1,
                      "",
                      this.state.sessiondata[i].market_id
                    )}
                  >
                    <span className="odd backprice">
                      {" "}
                      {this.state.sessiondata[i].BackPrice1}
                    </span>
                    {this.state.sessiondata[i].BackSize1}
                  </button>
                </td>

                <td className="fb_td" style={{ textAlign: "center" }}>
                  {" "}
                  Min 10 <br /> Max 10000{" "}
                </td>
              </tr>
            );
            new_array.push(new_array1);
          } else {
            if (this.state.sessiondata[i].LayPrice1 == 0) {
              fancy_suspend = "box-w1 lay-color fb_td suspended ";
            }
            if (this.state.sessiondata[i].BackPrice1 == 0) {
              fancy_suspend1 = "box-w1 back-color fb_td suspended";
            }
            new_array1 = (
              <tr>
                <td className="fb_64">
                  <a href="#">
                    {" "}
                    {this.state.sessiondata[i].RunnerName}
                    &nbsp;{" "}
                  </a>
                </td>
                <td className={fancy_suspend}>
                  <button value={i} className="bet-sec lay">
                    <span className="odd layprice">
                      {" "}
                      {this.state.sessiondata[i].LayPrice1}
                    </span>
                    {this.state.sessiondata[i].LaySize1}
                  </button>
                </td>

                <td className="box-w1 back-color fb_td">
                  <button className="bet-sec back" value={i}>
                    <span className="odd backprice">
                      {" "}
                      {this.state.sessiondata[i].BackPrice1}
                    </span>
                    {this.state.sessiondata[i].BackSize1}
                  </button>
                </td>

                <td className="fb_td" style={{ textAlign: "center" }}>
                  {" "}
                  Min 10 <br /> Max 10000{" "}
                </td>
              </tr>
            );
            new_array.push(new_array1);
          }
        } else {
          if (this.state.sessiondata[i].LayPrice1 == 0) {
            fancy_suspend = "box-w1 lay-color fb_td suspended ";
          }
          if (this.state.sessiondata[i].BackPrice1 == 0) {
            fancy_suspend1 = "box-w1 back-color fb_td suspended";
          }
          new_array1 = (
            <tr>
              <td className="fb_64">
                <a href="#">
                  {" "}
                  {this.state.sessiondata[i].RunnerName}
                  &nbsp;{" "}
                </a>
              </td>
              <td className={fancy_suspend}>
                <button value={i} className="bet-sec lay">
                  <span className="odd layprice">
                    {" "}
                    {this.state.sessiondata[i].LayPrice1}
                  </span>
                  {this.state.sessiondata[i].LaySize1}
                </button>
              </td>
              <td className="box-w1 back-color fb_td">
                <button
                  className="bet-sec back"
                  value={i}
                  onClick={this.handleBidClickSession.bind(
                    this,
                    "#72bbef",
                    this.state.sessiondata[i].RunnerName,
                    "no",
                    this.state.sessiondata[i].marketId,
                    this.state.sessiondata[i].BackPrice1,
                    "",
                    this.state.sessiondata[i].market_id
                  )}
                >
                  <span className="odd backprice">
                    {" "}
                    {this.state.sessiondata[i].BackPrice1}
                  </span>
                  {this.state.sessiondata[i].BackSize1}
                </button>
              </td>{" "}
              <td className="fb_td" style={{ textAlign: "center" }}>
                {" "}
                Min 10 <br /> Max 10000{" "}
              </td>
            </tr>
          );
          new_array.push(new_array1);
        }
      }
    }

    var accessToken = this.state.accessToken;

    if (accessToken === "" || accessToken === null) {
      return <Redirect to="/login" />;
    }
    var newdata11 = this.state.getResult11;
    //////console.log)
    var amount_data2 = "";
    var amount_data1 = "";
    var amount_data3 = "";
    var amount_data4 = "";
    var stake = "";
    if (
      this.state.color_data_model != "" &&
      this.state.color_data_model != undefined
    ) {
      if (this.state.color_data_model.showdata != undefined) {
        if (
          this.state.color_data_model.showdata.yes != undefined &&
          this.state.color_data_model.showdata.yes != ""
        ) {
          amount_data3 = "-";
        }
        if (
          this.state.color_data_model.showdata.no != undefined &&
          this.state.color_data_model.showdata.no != ""
        ) {
          amount_data4 = "-";
        }
        stake = this.state.color_data_model.showdata.stake;
      }
    }
    var new_fancy_arr = [];
    var stake = 0;
    if (this.state.no_data_model != undefined) {
      if (this.state.no_data_model.data != undefined) {
        if (this.state.no_data_model.data.showdata != undefined) {
          for (
            var index = 0;
            index < this.state.no_data_model.data.showdata.length;
            index++
          ) {
            stake += parseFloat(
              this.state.no_data_model.data.showdata[index].stake
            );
          }
          var new_array12333 = (
            <div>
              <div className="row form-group">
                <div className="col-md-4">
                  <label></label>
                </div>
                <div className="col-md-8">Amount</div>
              </div>
              <div className="row form-group">
                <div className="col-md-4">-{stake}</div>
              </div>
            </div>
          );
          new_fancy_arr.push(new_array12333);
        }
      }
    }

    if (this.state.teamOneLastBack != undefined) {
      return (
        <div className="h-100 App">
          <Header />
          <div id="wrapper">
            <div id="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-9 featured-box-detail">
                    <div className="coupon-card">
                      <div className="game-heading">
                        {" "}
                        <span className="card-header-title">
                          {this.state.firstTeamName} v{" "}
                          {this.state.secondTeamName}
                        </span>
                        <span
                          className="card-header-title"
                          style={{ float: "right" }}
                        >
                          {Moment(this.state.openMatchDate).format("lll")}
                        </span>
                      </div>{" "}
                      <br></br>
                      <div className="game-heading">
                        {" "}
                        <span className="card-header-title">
                          MATCH ODDS{" "}
                          <a
                            href="#"
                            className=" m-r-5 game-rules-icon blinking"
                            data-id="match"
                          >
                            <span>
                              <i className="fa fa-info-circle float-right"></i>
                            </span>
                          </a>
                        </span>{" "}
                        <span className="float-right m-r-10">
                          Maximum Bet : <span id="maxbetlmt"></span>
                        </span>
                        <span className="float-right m-r-10">
                          Minimum Bet : <span id="maxbetlmt"></span>
                        </span>
                      </div>
                      <div className="card-content">
                        <div
                          className="table-responsive m-b-10 main-market market-bf"
                          data-marketid="1.167146463"
                        >
                          <table className="table coupon-table table table-striped table-bordered m-t-10 ">
                            <thead>
                              <tr>
                                <th>
                                  Total Match: {this.state.twoteamtotalmatch}
                                </th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="back box-w1">Back</th>
                                <th className="lay box-w1">Lay</th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="box-w1">&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody id="dyn_bind">
                              <tr className="bet-info">
                                <td className="team-name nation table-active">
                                  <span>
                                    <strong>{this.state.firstTeamName}</strong>
                                  </span>

                                  <p className="box-w4">
                                    <span className="float-left book">
                                      <span
                                        className={
                                          this.state.first_team_data > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }
                                      >
                                        {this.state.first_team_data}
                                      </span>
                                    </span>
                                  </p>
                                </td>

                                <td
                                  className="box-w1 back-color"
                                  id="blockin1"
                                  style={{ backgroundColor: "#B2D6F0" }}
                                >
                                  {blockOddsHtml}
                                  {status}

                                  <button className="bet-sec back">
                                    {" "}
                                    <span className="odd backprice">
                                      {this.state.teamOneLastBack}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamOneLastBackSize}{" "}
                                    </span>{" "}
                                  </button>
                                </td>
                                <td
                                  id="blockin2"
                                  className="box-w1 back-color"
                                  style={{ backgroundColor: "#92C9F0" }}
                                >
                                  {status}
                                  <button className="bet-sec back">
                                    <span className="odd backprice">
                                      {this.state.teamOneMiddleBack}
                                    </span>
                                    <span className="oddsize">
                                      {" "}
                                      {this.state.teamOneMiddleBackSize}
                                    </span>
                                  </button>
                                </td>

                                <td id="blockin3" className="box-w1 back-color">
                                  {status}
                                  <button className="bet-sec back ">
                                    {" "}
                                    <span className="odd backprice">
                                      {this.state.teamOneFirstBack}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamOneFirstBackSize}{" "}
                                    </span>
                                  </button>
                                </td>

                                <td id="blockin4" className="box-w1 lay-color">
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamOneFirstLay}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamOneFirstLaySize}
                                    </span>
                                  </button>
                                </td>
                                <td
                                  id="blockin5"
                                  className="box-w1 lay-color"
                                  style={{ backgroundColor: "#F8BBC8" }}
                                >
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamOneMiddleLay}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamOneMiddleLaySize}
                                    </span>
                                  </button>
                                </td>
                                <td
                                  id="blockin6"
                                  className="box-w1 lay-color"
                                  style={{ backgroundColor: "#F6CDD6" }}
                                >
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamOneLastLay}
                                    </span>{" "}
                                    <span className="oddsize">
                                      {this.state.teamOneLastLaySize}
                                    </span>
                                  </button>
                                </td>
                              </tr>
                              <tr className="bet-info">
                                <td
                                  className="team-name nation table-active"
                                  id="10301"
                                >
                                  <span>
                                    <strong>{this.state.secondTeamName}</strong>
                                  </span>
                                  <p className="box-w4">
                                    <span className="float-left book">
                                      <span
                                        className={
                                          this.state.second_team_data > 0
                                            ? "text-success"
                                            : "text-danger"
                                        }
                                      >
                                        {this.state.second_team_data}
                                      </span>
                                    </span>{" "}
                                  </p>
                                </td>
                                <td
                                  id="blockin7"
                                  className="box-w1 back-color"
                                  style={{ backgroundColor: "#B2D6F0" }}
                                >
                                  {blockOddsHtml}
                                  {status}
                                  <button className="bet-sec back ">
                                    {" "}
                                    <span className="odd backprice">
                                      {this.state.teamTwoLastBack}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamTwoLastBackSize}
                                    </span>
                                  </button>
                                </td>
                                <td
                                  id="blockin8"
                                  className="box-w1 back-color"
                                  style={{ backgroundColor: "#92C9F0" }}
                                >
                                  {status}
                                  <button className="bet-sec back ">
                                    {" "}
                                    <span className="odd backprice">
                                      {this.state.teamTwoMiddleBack}
                                    </span>{" "}
                                    <span className="oddsize">
                                      {this.state.teamTwoMiddleBackSize}
                                    </span>{" "}
                                  </button>
                                </td>

                                <td id="blockin9" className="box-w1 back-color">
                                  {status}
                                  <button className="bet-sec back ">
                                    {" "}
                                    <span className="odd backprice">
                                      {this.state.teamTwoFirstBack}
                                    </span>{" "}
                                    <span className="oddsize">
                                      {this.state.teamTwoFirstBackSize}
                                    </span>{" "}
                                  </button>
                                </td>

                                <td id="blockin10" className="box-w1 lay-color">
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamTwoFirstLay}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamTwoFirstLaySize}
                                    </span>
                                  </button>
                                </td>
                                <td
                                  id="blockin11"
                                  className="box-w1 lay-color"
                                  style={{ backgroundColor: "#F8BBC8" }}
                                >
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamTwoMiddleLay}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamTwoMiddleLaySize}
                                    </span>
                                  </button>
                                </td>
                                <td
                                  id="blockin12"
                                  className="box-w1 lay-color"
                                  style={{ backgroundColor: "#F6CDD6" }}
                                >
                                  {status}
                                  <button
                                    className="bet-sec lay"
                                    value={this.state.lastPriceTraded1}
                                  >
                                    <span className="odd layprice">
                                      {this.state.teamTwoLastLay}
                                    </span>
                                    <span className="oddsize">
                                      {this.state.teamTwoLastLaySize}
                                    </span>
                                  </button>
                                </td>
                              </tr>
                              {/* {this.state.drawTeamName !== null
                                ? this.showDrawHtml()
                                : null} */}
                              {this.showDrawHtml()}
                            </tbody>
                          </table>
                        </div>
                        <div className="">
                          <div className="row row-12 ssw_66">
                            <div className="col-md-12" id="fancyHeadToHide">
                              <div class="game-heading">
                                {" "}
                                <span class="card-header-title">
                                  Bookmaker Market{" "}
                                  <a
                                    href="#"
                                    class=" m-r-5 game-rules-icon blinking"
                                    data-id="match"
                                  >
                                    <span>
                                      <i class="fa fa-info-circle float-right"></i>
                                    </span>
                                  </a>
                                </span>
                                <span class="float-right m-r-10">
                                  Maximum Bet :{" "}
                                  <span id="maxbetlmt">
                                    {this.state.max_bookmaker_limit}
                                  </span>
                                </span>
                                <span class="float-right m-r-10">
                                  Minimum Bet :
                                  <span id="maxbetlmt">
                                    {this.state.min_bookmaker_limit}
                                  </span>
                                </span>
                              </div>

                              <div id="div_fancy">
                                <div className="card-content">
                                  <div
                                    className="table-responsives  m-b-10 main-market market-bf"
                                    data-marketid="1.167146463"
                                  >
                                    <div className="table new_table  coupon-table table table-striped table-bordered m-t-10 ">
                                      {this.showBookMarketAllHtml()}
                                      {/* {this.showBookmakerAdmindataHtml()} */}
                                    </div>
                                  </div>
                                </div>
                                <div className="">
                                  <div className="row row-12 ball_running">
                                    <div
                                      className="col-md-12"
                                      id="fancyHeadToHide"
                                    >
                                      <div className="fancy-marker-title">
                                        <h4>
                                          Fancy Bet{" "}
                                          <a
                                            href="#"
                                            className=" m-r-5 game-rules-icon blinking"
                                            data-id="fancy"
                                          >
                                            <span>
                                              <i className="fa fa-info-circle float-right"></i>
                                            </span>
                                          </a>
                                        </h4>
                                      </div>
                                      <div id="div_fancy">
                                        {/* <table className="table coupon-table table table-striped table-bordered m-t-10 ">
                                          {new_array}
                                        </table> */}
                                        {this.showFancyApiHtml()}
                                        {new_array}
                                      </div>
                                    </div>
                                    <div className="col-md-6 fancy-market"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 fancy-market"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 sidebar-right">
                    <div
                      className="card-header"
                      data-toggle="collapse"
                      data-target="#demo"
                      onClick={this.handleLiveTvClick}
                    >
                      <div className="row33">
                        <div className="col-33">
                          <button
                            type="button"
                            data-toggle="dropdown"
                            class="btn btn-primary dropdown-toggle"
                          >
                            Bet Lock <span class="caret"></span>
                          </button>

                          <ul class="dropdown-menu">
                            <li>
                              <a
                                onClick={this.handleBetLockClick.bind(
                                  this,
                                  1,
                                  "odds"
                                )}
                                href="#"
                              >
                                Lock
                              </a>
                            </li>
                            <li>
                              <a
                                onClick={this.handleBetLockClick.bind(
                                  this,
                                  2,
                                  "odds"
                                )}
                                href="#"
                              >
                                Unlock
                              </a>
                            </li>
                            <li>
                              <a
                                onClick={this.handleBetLockClick.bind(
                                  this,
                                  3,
                                  "odds"
                                )}
                                href="#"
                              >
                                Select user
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="col-33">
                          <div class="dropdown">
                            <button
                              class="btn btn-primary dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              Fancy Lock
                            </button>
                            <div
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    1,
                                    "fancy"
                                  )}
                                  href="#"
                                >
                                  Lock
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    2,
                                    "fancy"
                                  )}
                                  href="#"
                                >
                                  Unlock
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    3,
                                    "fancy"
                                  )}
                                  href="#"
                                >
                                  Select user
                                </a>
                              </li>
                            </div>
                          </div>
                        </div>
                        <div className="col-33">
                          <button
                            onClick={this.handleUserLockClick}
                            class="btn btn-primary"
                          >
                            User Book
                          </button>
                        </div>

                        <div className="col-33">
                          <button
                            onClick={this.handleUserBookClick}
                            class="btn btn-primary"
                          >
                            Bookmaker Book
                          </button>
                        </div>
                        <div className="col-33">
                          <div class="dropdown">
                            <button
                              class="btn btn-primary dropdown-toggle"
                              type="button"
                              id="dropdownMenuButton1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              Bookmaker Lock
                            </button>
                            <div
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    1,
                                    "bookmaker"
                                  )}
                                  href="#"
                                >
                                  Lock
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    2,
                                    "bookmaker"
                                  )}
                                  href="#"
                                >
                                  Unlock
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={this.handleBetLockClick1.bind(
                                    this,
                                    3,
                                    "bookmaker"
                                  )}
                                  href="#"
                                >
                                  Select user
                                </a>
                              </li>
                            </div>
                          </div>
                        </div>
                      </div>

                      <h6 className="card-title">
                        Live Match{" "}
                        <span className="float-right">
                          <i className="fa fa-tv"></i> live stream started
                        </span>{" "}
                      </h6>
                    </div>

                    <div id="demo" className="collapse hide ">
                      <ul className="nav nav-tabs video_nav_tab">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-toggle="tab"
                            href="#video1"
                          >
                            Channel 1
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#video2"
                          >
                            Channel 2
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#video3"
                          >
                            Channel 3
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-toggle="tab"
                            href="#video4"
                          >
                            Channel 4
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div id="video1" className=" tab-pane active">
                          <iframe
                            className="tab_video"
                            src="https://video.indibetsportsbook.com:8888/embed_player?urlServer=wss://video.indibetsportsbook.com:8443&streamName=ch_1&autoplay=false&mediaProviders=WebRTC,Flash,MSE,WSPlayer"
                          ></iframe>
                        </div>
                        <div id="video2" className=" tab-pane fade">
                          <iframe
                            className="tab_video"
                            src="https://video.indibetsportsbook.com:8888/embed_player?urlServer=wss://video.indibetsportsbook.com:8443&streamName=ch_2&autoplay=false&mediaProviders=WebRTC,Flash,MSE,WSPlayer"
                          ></iframe>
                        </div>
                        <div id="video3" className=" tab-pane fade">
                          <iframe
                            className="tab_video"
                            src=" https://video.indibetsportsbook.com:8888/embed_player?urlServer=wss://video.indibetsportsbook.com:8443&streamName=ch_3&autoplay=false&mediaProviders=WebRTC,Flash,MSE,WSPlayer"
                          ></iframe>
                        </div>
                        <div id="video4" className=" tab-pane fade">
                          <iframe
                            className="tab_video"
                            src="https://video.indibetsportsbook.com:8888/embed_player?urlServer=wss://video.indibetsportsbook.com:8443&streamName=ch_4&autoplay=false&mediaProviders=WebRTC,Flash,MSE,WSPlayer"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                    <div className="card m-b-10 mt-3 place-bet ">
                      <div className="card-header">
                        <h6 className="card-title d-inline-block">Place Bet</h6>
                        <a
                          className="btn btn-secondary float-right change-value"
                          id="cng_btn_val"
                          href="#"
                        >
                          Change Button Value
                        </a>
                      </div>
                    </div>
                    <div className="card place-bet">
                      <div className="card-header">
                        <h6 className="card-title d-inline-block">My Bet</h6>
                      </div>
                      <div
                        className="table-responsive hide-box-click"
                        style={{ display: "block" }}
                      >
                        {this.showBetUpdateRespHtml()}
                        {this.showTableHtml()}
                      </div>
                    </div>
                    <form
                      onSubmit={this.handleFancybetSubmit}
                      method="post"
                      id="frm_placebet"
                    >
                      <table className="table table-borderedless place-bet">
                        <tbody>
                          {this.getFancybet()}
                          {this.getFancybetPoint()}
                          <br></br>
                          {this.getFancySecondbet()}
                          {this.getSecondFancybetPoint()}
                        </tbody>
                      </table>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              className="admin-trns"
              show={this.state.betlockHistory}
              onHide={this.betlockHistoryHide2}
            >
              <a
                class="close"
                data-dismiss="modal"
                onClick={this.betlockHistoryHide2}
              >
                ×
              </a>
              <Modal.Header>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive">
                      <table
                        id="account-statement"
                        className="display dataTable"
                      >
                        <thead>
                          <tr role="row">
                            <th>User Name</th>
                            <th>Bet Status</th>
                            <th>Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        {this.showTableHtmlBetLock()}
                      </table>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
            <Modal
              className="admin-trns"
              show={this.state.userLogHistory}
              onHide={this.userLogkHistoryHide}
            >
              <a
                class="close"
                data-dismiss="modal"
                onClick={this.userLogHistoryHide}
              >
                ×
              </a>
              <Modal.Header>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive">
                      <table
                        id="account-statement"
                        className="display dataTable"
                      >
                        <thead>
                          <tr role="row">
                            <th>User Name</th>
                            <th>{this.state.firstTeamName}</th>
                            <th>{this.state.secondTeamName}</th>
                            <th>Draw Team Total</th>
                          </tr>
                        </thead>

                        {this.showTableUserLock()}
                      </table>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>

            <Modal show={this.state.showUserAmountPopup}>
              <Modal.Header>
                <Modal.Title>Run Position</Modal.Title>
              </Modal.Header>
              <Modal.Body>{new_fancy_arr}</Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.handleDepoWithdrPopupClose}
                >
                  <i className="fas fa-undo-alt"></i> Close
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Header />
          <div id="wrapper">
            <div id="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-9 featured-box-detail">
                    <div className="coupon-card">
                      <div className="game-heading">
                        {" "}
                        <span className="card-header-title">
                          MATCH ODDS{" "}
                          <a
                            href="#"
                            className=" m-r-5 game-rules-icon blinking"
                            data-id="match"
                          >
                            <span>
                              <i className="fa fa-info-circle float-right"></i>
                            </span>
                          </a>
                        </span>{" "}
                        <span className="float-right m-r-10">
                          {" "}
                          <span id="maxbetlmt">
                            {this.state.userCurretBalance}
                          </span>
                        </span>{" "}
                      </div>
                      <div className="card-content">
                        <div
                          className="table-responsive m-b-10 main-market market-bf"
                          data-marketid="1.167146463"
                        >
                          <table className="table coupon-table table table-striped table-bordered m-t-10 ">
                            <thead>
                              <tr>
                                <th>
                                  Total Match: {this.state.twoteamtotalmatch}
                                </th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="back box-w1">Back</th>
                                <th className="lay box-w1">Lay</th>
                                <th className="box-w1">&nbsp;</th>
                                <th className="box-w1">&nbsp;</th>
                              </tr>
                            </thead>
                          </table>
                        </div>

                        <div className="">
                          <div className="row row-12">
                            <div className="col-md-12" id="fancyHeadToHide">
                              <div className="fancy-marker-title">
                                <h4>
                                  Bookmaker Market{" "}
                                  <a
                                    href="#"
                                    className=" m-r-5 game-rules-icon blinking"
                                    data-id="fancy"
                                  >
                                    <span>
                                      <i className="fa fa-info-circle float-right"></i>
                                    </span>
                                  </a>
                                </h4>
                              </div>
                            </div>
                            <div className="col-md-6 fancy-market"></div>
                          </div>

                          <div className="row row-12 ">
                            <div className="col-md-12" id="fancyHeadToHide">
                              <div className="fancy-marker-title">
                                <h4>
                                  Fancy Bet{" "}
                                  <a
                                    href="#"
                                    className=" m-r-5 game-rules-icon blinking"
                                    data-id="fancy"
                                  >
                                    <span>
                                      <i className="fa fa-info-circle float-right"></i>
                                    </span>
                                  </a>
                                </h4>
                              </div>
                              <div id="div_fancy">{new_array}</div>
                            </div>
                            <div className="col-md-6 fancy-market"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 sidebar-right">
                    <div
                      className="card-header m-b-10"
                      data-toggle="collapse"
                      data-target="#demo"
                      onClick={this.handleLiveTvClick}
                    >
                      <h6 className="card-title">
                        Live Match{" "}
                        <span className="float-right">
                          <i className="fa fa-tv"></i> live stream started
                        </span>{" "}
                      </h6>
                    </div>
                    <div id="demo" className="collapse hide m-b-10">
                      {this.showVideo()}
                    </div>
                    <div className="card m-b-10 place-bet ">
                      <div className="card-header">
                        <h6 className="card-title d-inline-block">Place Bet</h6>
                        <a
                          className="btn btn-secondary float-right change-value"
                          id="cng_btn_val"
                          href="#"
                        >
                          Change Button Value
                        </a>
                      </div>
                    </div>
                    <div className="card m-b-10 place-bet">
                      <div className="card-header">
                        <h6 className="card-title d-inline-block">My Bet</h6>
                        <a
                          className="btn btn-danger float-right change-value"
                          id="cng_btn_val"
                          href="#"
                        >
                          ClearAll
                        </a>
                      </div>
                      <div
                        className="table-responsive hide-box-click "
                        style={{ paddingBottom: "4px", display: "block" }}
                      >
                        {this.showBetUpdateRespHtml()}
                        {this.showTableHtml()}
                      </div>
                    </div>
                    <form
                      onSubmit={this.handleFancybetSubmit}
                      method="post"
                      id="frm_placebet"
                    >
                      <table className="table table-borderedless place-bet">
                        <thead>
                          <tr>
                            <th></th>
                            <th style={{ width: "35%", textAlign: "left" }}>
                              (Bet for)
                            </th>
                            <th style={{ width: "35%", textAlign: "left" }}>
                              Odds
                            </th>
                            <th style={{ width: "35%", textAlign: "left" }}>
                              Stake
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.getFancybet()}
                          {this.getFancybetPoint()}
                          <br></br>
                          {this.getFancySecondbet()}
                          {this.getSecondFancybetPoint()}
                        </tbody>
                      </table>
                      <div className="col-md-12">
                        <button
                          className="btn btn-sm btn-danger float-left"
                          type="button"
                          onClick={this.cancelCourse}
                        >
                          Reset
                        </button>
                        <button
                          className="btn btn-sm btn-success float-right"
                          type="submit"
                          id="submit_btn"
                        >
                          Submit
                        </button>
                        <input
                          id="Odds1"
                          type="hidden"
                          value={this.state.lastPriceTraded1}
                          onChange={this.handleChange}
                        />
                        <input
                          id="Odds2"
                          type="hidden"
                          value={this.state.lastPriceTraded2}
                          onChange={this.handleChange}
                        />
                        <input
                          id="team_id1"
                          type="hidden"
                          value={this.state.teamid1}
                          onChange={this.handleChange}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Admin/Matchdetail.js